/* tslint:disable */
/* eslint-disable */
/**
 * CAST.AI API documentation
 * ### Feature maturity indicators (may appear on resources, operations and request/response fields)  - **(BETA)** - new or experimental features, subject to change  - **(Deprecated)** - outdated or replaced features (a reason and removal date will be provided in the description) 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { WorkloadOptimizationAPIAssignScalingPolicyWorkloadsRequest } from '../models';
// @ts-ignore
import type { WorkloadOptimizationAPIDisableClusterRequest } from '../models';
// @ts-ignore
import type { WorkloadOptimizationAPIEnableClusterRequest } from '../models';
// @ts-ignore
import type { WorkloadOptimizationAPIPatchWorkloadScalingPolicyRequest } from '../models';
// @ts-ignore
import type { WorkloadOptimizationAPIPatchWorkloadV2Request } from '../models';
// @ts-ignore
import type { WorkloadOptimizationAPIQueryWorkloadMetricsRequest } from '../models';
// @ts-ignore
import type { WorkloadOptimizationAPIResetSystemOverridesRequest } from '../models';
// @ts-ignore
import type { WorkloadOptimizationAPISetScalingPoliciesOrderRequest } from '../models';
// @ts-ignore
import type { WorkloadOptimizationAPISyncSystemPolicyAssignmentRulesRequest } from '../models';
// @ts-ignore
import type { WorkloadOptimizationAPIUpdateCustomMetricsDataSourceRequest } from '../models';
// @ts-ignore
import type { WorkloadoptimizationV1CustomMetricsDataSource } from '../models';
// @ts-ignore
import type { WorkloadoptimizationV1DisableClusterResponse } from '../models';
// @ts-ignore
import type { WorkloadoptimizationV1GetAdoptionWeightedCPUResponse } from '../models';
// @ts-ignore
import type { WorkloadoptimizationV1GetAgentStatusResponse } from '../models';
// @ts-ignore
import type { WorkloadoptimizationV1GetAggregatedWorkloadCustomMetricsV1BetaResponse } from '../models';
// @ts-ignore
import type { WorkloadoptimizationV1GetHPAV2MigrationEligibilityResponse } from '../models';
// @ts-ignore
import type { WorkloadoptimizationV1GetOrganizationAgentStatusesResponse } from '../models';
// @ts-ignore
import type { WorkloadoptimizationV1GetWorkloadCustomMetricsV1BetaResponse } from '../models';
// @ts-ignore
import type { WorkloadoptimizationV1GetWorkloadEventResponse } from '../models';
// @ts-ignore
import type { WorkloadoptimizationV1GetWorkloadEventsSummaryResponse } from '../models';
// @ts-ignore
import type { WorkloadoptimizationV1GetWorkloadFiltersResponse } from '../models';
// @ts-ignore
import type { WorkloadoptimizationV1GetWorkloadGPUMetricsResponse } from '../models';
// @ts-ignore
import type { WorkloadoptimizationV1GetWorkloadNativeVpaSpecResponse } from '../models';
// @ts-ignore
import type { WorkloadoptimizationV1GetWorkloadRecommendationManifestResponse } from '../models';
// @ts-ignore
import type { WorkloadoptimizationV1GetWorkloadResponse } from '../models';
// @ts-ignore
import type { WorkloadoptimizationV1GetWorkloadSpecResponse } from '../models';
// @ts-ignore
import type { WorkloadoptimizationV1GetWorkloadsAccessContextResponse } from '../models';
// @ts-ignore
import type { WorkloadoptimizationV1GetWorkloadsSummaryMetricsResponse } from '../models';
// @ts-ignore
import type { WorkloadoptimizationV1GetWorkloadsSummaryResponse } from '../models';
// @ts-ignore
import type { WorkloadoptimizationV1ListClusterHPAsResponse } from '../models';
// @ts-ignore
import type { WorkloadoptimizationV1ListCustomMetricsDataSourcesResponse } from '../models';
// @ts-ignore
import type { WorkloadoptimizationV1ListLimitRangesResponse } from '../models';
// @ts-ignore
import type { WorkloadoptimizationV1ListResourceQuotasResponse } from '../models';
// @ts-ignore
import type { WorkloadoptimizationV1ListWorkloadEventsResponse } from '../models';
// @ts-ignore
import type { WorkloadoptimizationV1ListWorkloadScalingPoliciesResponse } from '../models';
// @ts-ignore
import type { WorkloadoptimizationV1ListWorkloadsResponse } from '../models';
// @ts-ignore
import type { WorkloadoptimizationV1NewCustomMetricsDataSource } from '../models';
// @ts-ignore
import type { WorkloadoptimizationV1NewWorkloadScalingPolicy } from '../models';
// @ts-ignore
import type { WorkloadoptimizationV1QueryWorkloadMetricsResponse } from '../models';
// @ts-ignore
import type { WorkloadoptimizationV1ResetSystemOverridesResponse } from '../models';
// @ts-ignore
import type { WorkloadoptimizationV1SyncSystemPolicyAssignmentRulesResponse } from '../models';
// @ts-ignore
import type { WorkloadoptimizationV1UpdateWorkloadResponseV2 } from '../models';
// @ts-ignore
import type { WorkloadoptimizationV1UpdateWorkloadScalingPolicy } from '../models';
// @ts-ignore
import type { WorkloadoptimizationV1UpdateWorkloadV2 } from '../models';
// @ts-ignore
import type { WorkloadoptimizationV1WorkloadScalingPolicy } from '../models';
/**
 * WorkloadOptimizationAPIApi - axios parameter creator
 * @export
 */
export const WorkloadOptimizationAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Assigns the provided list of workload IDs to the specified policy.
         * @param {string} clusterId Cluster ID associated with the scaling policy.
         * @param {string} policyId Policy ID associated with the scaling policy.
         * @param {WorkloadOptimizationAPIAssignScalingPolicyWorkloadsRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIAssignScalingPolicyWorkloads: async (clusterId: string, policyId: string, body: WorkloadOptimizationAPIAssignScalingPolicyWorkloadsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('workloadOptimizationAPIAssignScalingPolicyWorkloads', 'clusterId', clusterId)
            // verify required parameter 'policyId' is not null or undefined
            assertParamExists('workloadOptimizationAPIAssignScalingPolicyWorkloads', 'policyId', policyId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('workloadOptimizationAPIAssignScalingPolicyWorkloads', 'body', body)
            const localVarPath = `/v1/workload-autoscaling/clusters/{clusterId}/policies/{policyId}/workloads`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"policyId"}}`, encodeURIComponent(String(policyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates a custom metrics data source for given cluster.
         * @param {string} clusterId 
         * @param {WorkloadoptimizationV1NewCustomMetricsDataSource} dataSource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPICreateCustomMetricsDataSource: async (clusterId: string, dataSource: WorkloadoptimizationV1NewCustomMetricsDataSource, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('workloadOptimizationAPICreateCustomMetricsDataSource', 'clusterId', clusterId)
            // verify required parameter 'dataSource' is not null or undefined
            assertParamExists('workloadOptimizationAPICreateCustomMetricsDataSource', 'dataSource', dataSource)
            const localVarPath = `/v1/workload-autoscaling/clusters/{clusterId}/custom-metrics/configs/data-sources`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dataSource, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates a scaling policy that can be assigned to workloads at a later time.
         * @param {string} clusterId 
         * @param {WorkloadoptimizationV1NewWorkloadScalingPolicy} policy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPICreateWorkloadScalingPolicy: async (clusterId: string, policy: WorkloadoptimizationV1NewWorkloadScalingPolicy, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('workloadOptimizationAPICreateWorkloadScalingPolicy', 'clusterId', clusterId)
            // verify required parameter 'policy' is not null or undefined
            assertParamExists('workloadOptimizationAPICreateWorkloadScalingPolicy', 'policy', policy)
            const localVarPath = `/v1/workload-autoscaling/clusters/{clusterId}/policies`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(policy, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes a custom metrics data source.
         * @param {string} clusterId The cluster ID that owns this custom metrics data source.
         * @param {string} id The ID of the custom metrics data source to delete.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIDeleteCustomMetricsDataSource: async (clusterId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('workloadOptimizationAPIDeleteCustomMetricsDataSource', 'clusterId', clusterId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('workloadOptimizationAPIDeleteCustomMetricsDataSource', 'id', id)
            const localVarPath = `/v1/workload-autoscaling/clusters/{clusterId}/custom-metrics/configs/data-sources/{id}`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes a scaling policy.
         * @param {string} clusterId 
         * @param {string} policyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIDeleteWorkloadScalingPolicy: async (clusterId: string, policyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('workloadOptimizationAPIDeleteWorkloadScalingPolicy', 'clusterId', clusterId)
            // verify required parameter 'policyId' is not null or undefined
            assertParamExists('workloadOptimizationAPIDeleteWorkloadScalingPolicy', 'policyId', policyId)
            const localVarPath = `/v1/workload-autoscaling/clusters/{clusterId}/policies/{policyId}`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"policyId"}}`, encodeURIComponent(String(policyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary DisableCluster temporarily disables workload optimization for a cluster. This is an internal-only endpoint used by the admin service.
         * @param {string} clusterId 
         * @param {WorkloadOptimizationAPIDisableClusterRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIDisableCluster: async (clusterId: string, body: WorkloadOptimizationAPIDisableClusterRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('workloadOptimizationAPIDisableCluster', 'clusterId', clusterId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('workloadOptimizationAPIDisableCluster', 'body', body)
            const localVarPath = `/v1/admin/workload-autoscaling/clusters/{clusterId}:disable`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary EnableCluster re-enables workload optimization for a temporarily disabled cluster. This is an internal-only endpoint used by the admin service.
         * @param {string} clusterId 
         * @param {WorkloadOptimizationAPIEnableClusterRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIEnableCluster: async (clusterId: string, body: WorkloadOptimizationAPIEnableClusterRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('workloadOptimizationAPIEnableCluster', 'clusterId', clusterId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('workloadOptimizationAPIEnableCluster', 'body', body)
            const localVarPath = `/v1/admin/workload-autoscaling/clusters/{clusterId}:enable`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Requests generation of recommendation for a workload
         * @param {string} clusterId 
         * @param {string} workloadId 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIGenerateRecommendation: async (clusterId: string, workloadId: string, body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('workloadOptimizationAPIGenerateRecommendation', 'clusterId', clusterId)
            // verify required parameter 'workloadId' is not null or undefined
            assertParamExists('workloadOptimizationAPIGenerateRecommendation', 'workloadId', workloadId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('workloadOptimizationAPIGenerateRecommendation', 'body', body)
            const localVarPath = `/v1/workload-autoscaling/clusters/{clusterId}/workloads/{workloadId}/recommendation`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"workloadId"}}`, encodeURIComponent(String(workloadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the adoption-weighted CPU billing metric for the given organization+cluster+window.
         * @param {string} clusterId The cluster within the organization. Required, must be a valid UUID.
         * @param {string} organizationId The organization for which to compute the metric. Required, must be a valid UUID.
         * @param {string} from Inclusive start of the billing window. Required. Must be in the past and within the last 60 days (matches the workloads_summary TTL). Handler also enforces from &lt; to and (to - from) &lt;&#x3D; 30 days.
         * @param {string} to Exclusive end of the billing window. Required. Must be in the past and within the last 60 days (matches the workloads_summary TTL). Handler also enforces from &lt; to and (to - from) &lt;&#x3D; 30 days.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIGetAdoptionWeightedCPU: async (clusterId: string, organizationId: string, from: string, to: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('workloadOptimizationAPIGetAdoptionWeightedCPU', 'clusterId', clusterId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('workloadOptimizationAPIGetAdoptionWeightedCPU', 'organizationId', organizationId)
            // verify required parameter 'from' is not null or undefined
            assertParamExists('workloadOptimizationAPIGetAdoptionWeightedCPU', 'from', from)
            // verify required parameter 'to' is not null or undefined
            assertParamExists('workloadOptimizationAPIGetAdoptionWeightedCPU', 'to', to)
            const localVarPath = `/v1/workload-autoscaling/clusters/{clusterId}/billing/adoption-weighted-cpu`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns status of workload-autoscaler agent.
         * @param {string} clusterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIGetAgentStatus: async (clusterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('workloadOptimizationAPIGetAgentStatus', 'clusterId', clusterId)
            const localVarPath = `/v1/workload-autoscaling/clusters/{clusterId}/components/workload-autoscaler`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GetAggregatedWorkloadCustomMetrics returns aggregated custom metrics time-series data. Pods are aggregated across the workload, grouped by metric name and container.
         * @param {string} clusterId 
         * @param {string} workloadId 
         * @param {string} containerName 
         * @param {string} fromTime 
         * @param {string} toTime 
         * @param {string} aggregationSlidingWindow Sliding window duration for aggregation (e.g. 30 minutes).
         * @param {WorkloadOptimizationAPIGetAggregatedWorkloadCustomMetricsV1BetaAggregationTypeEnum} aggregationType 
         * @param {string} [step] Sampling interval for metrics. The server may enforce a step even when one is not provided, or change it if it\&#39;s too short. The actual step used is returned in the response.
         * @param {number} [aggregationPercentile] Only used when type is PERCENTILE (e.g. 95 for p95).
         * @param {boolean} [backfillDataPoints] When true, missing data points in the time range are backfilled with null values at each step interval.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIGetAggregatedWorkloadCustomMetricsV1Beta: async (clusterId: string, workloadId: string, containerName: string, fromTime: string, toTime: string, aggregationSlidingWindow: string, aggregationType: WorkloadOptimizationAPIGetAggregatedWorkloadCustomMetricsV1BetaAggregationTypeEnum, step?: string, aggregationPercentile?: number, backfillDataPoints?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('workloadOptimizationAPIGetAggregatedWorkloadCustomMetricsV1Beta', 'clusterId', clusterId)
            // verify required parameter 'workloadId' is not null or undefined
            assertParamExists('workloadOptimizationAPIGetAggregatedWorkloadCustomMetricsV1Beta', 'workloadId', workloadId)
            // verify required parameter 'containerName' is not null or undefined
            assertParamExists('workloadOptimizationAPIGetAggregatedWorkloadCustomMetricsV1Beta', 'containerName', containerName)
            // verify required parameter 'fromTime' is not null or undefined
            assertParamExists('workloadOptimizationAPIGetAggregatedWorkloadCustomMetricsV1Beta', 'fromTime', fromTime)
            // verify required parameter 'toTime' is not null or undefined
            assertParamExists('workloadOptimizationAPIGetAggregatedWorkloadCustomMetricsV1Beta', 'toTime', toTime)
            // verify required parameter 'aggregationSlidingWindow' is not null or undefined
            assertParamExists('workloadOptimizationAPIGetAggregatedWorkloadCustomMetricsV1Beta', 'aggregationSlidingWindow', aggregationSlidingWindow)
            // verify required parameter 'aggregationType' is not null or undefined
            assertParamExists('workloadOptimizationAPIGetAggregatedWorkloadCustomMetricsV1Beta', 'aggregationType', aggregationType)
            const localVarPath = `/v1beta/workload-autoscaling/clusters/{clusterId}/workloads/{workloadId}/custom-metrics:aggregate`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"workloadId"}}`, encodeURIComponent(String(workloadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (containerName !== undefined) {
                localVarQueryParameter['containerName'] = containerName;
            }

            if (fromTime !== undefined) {
                localVarQueryParameter['fromTime'] = (fromTime as any instanceof Date) ?
                    (fromTime as any).toISOString() :
                    fromTime;
            }

            if (toTime !== undefined) {
                localVarQueryParameter['toTime'] = (toTime as any instanceof Date) ?
                    (toTime as any).toISOString() :
                    toTime;
            }

            if (step !== undefined) {
                localVarQueryParameter['step'] = step;
            }

            if (aggregationSlidingWindow !== undefined) {
                localVarQueryParameter['aggregationSlidingWindow'] = aggregationSlidingWindow;
            }

            if (aggregationType !== undefined) {
                localVarQueryParameter['aggregation.type'] = aggregationType;
            }

            if (aggregationPercentile !== undefined) {
                localVarQueryParameter['aggregation.percentile'] = aggregationPercentile;
            }

            if (backfillDataPoints !== undefined) {
                localVarQueryParameter['backfillDataPoints'] = backfillDataPoints;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns HPA v2 migration eligibility for a cluster
         * @param {string} clusterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIGetHPAV2MigrationEligibility: async (clusterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('workloadOptimizationAPIGetHPAV2MigrationEligibility', 'clusterId', clusterId)
            const localVarPath = `/v1/workload-autoscaling/clusters/{clusterId}/workloads/migrate-to-hpa-v2`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns status of workload-autoscaler agents for all clusters in an organization.
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIGetOrganizationAgentStatuses: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('workloadOptimizationAPIGetOrganizationAgentStatuses', 'organizationId', organizationId)
            const localVarPath = `/v1/workload-autoscaling/organizations/{organizationId}/components/workload-autoscaler`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a workload by a given id.
         * @param {string} clusterId 
         * @param {string} workloadId 
         * @param {boolean} [includeMetrics] 
         * @param {boolean} [includeCosts] 
         * @param {string} [fromTime] 
         * @param {string} [toTime] 
         * @param {string} [scopeValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIGetWorkload: async (clusterId: string, workloadId: string, includeMetrics?: boolean, includeCosts?: boolean, fromTime?: string, toTime?: string, scopeValue?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('workloadOptimizationAPIGetWorkload', 'clusterId', clusterId)
            // verify required parameter 'workloadId' is not null or undefined
            assertParamExists('workloadOptimizationAPIGetWorkload', 'workloadId', workloadId)
            const localVarPath = `/v1/workload-autoscaling/clusters/{clusterId}/workloads/{workloadId}`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"workloadId"}}`, encodeURIComponent(String(workloadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeMetrics !== undefined) {
                localVarQueryParameter['includeMetrics'] = includeMetrics;
            }

            if (includeCosts !== undefined) {
                localVarQueryParameter['includeCosts'] = includeCosts;
            }

            if (fromTime !== undefined) {
                localVarQueryParameter['fromTime'] = (fromTime as any instanceof Date) ?
                    (fromTime as any).toISOString() :
                    fromTime;
            }

            if (toTime !== undefined) {
                localVarQueryParameter['toTime'] = (toTime as any instanceof Date) ?
                    (toTime as any).toISOString() :
                    toTime;
            }

            if (scopeValue !== undefined) {
                localVarQueryParameter['scopeValue'] = scopeValue;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns raw custom metrics time-series data for a workload.
         * @param {string} clusterId 
         * @param {string} workloadId 
         * @param {string} containerName 
         * @param {string} fromTime 
         * @param {string} toTime 
         * @param {string} [step] Sampling interval for metrics. For long time ranges, the server may enforce a step even if one is not provided. The actual step used is returned in the response.
         * @param {boolean} [backfillDataPoints] When true, missing data points in the time range are backfilled with null values at each step interval. Requires a step to be in effect (explicitly requested or server-calculated). Ignored when no step applies.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIGetWorkloadCustomMetricsV1Beta: async (clusterId: string, workloadId: string, containerName: string, fromTime: string, toTime: string, step?: string, backfillDataPoints?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('workloadOptimizationAPIGetWorkloadCustomMetricsV1Beta', 'clusterId', clusterId)
            // verify required parameter 'workloadId' is not null or undefined
            assertParamExists('workloadOptimizationAPIGetWorkloadCustomMetricsV1Beta', 'workloadId', workloadId)
            // verify required parameter 'containerName' is not null or undefined
            assertParamExists('workloadOptimizationAPIGetWorkloadCustomMetricsV1Beta', 'containerName', containerName)
            // verify required parameter 'fromTime' is not null or undefined
            assertParamExists('workloadOptimizationAPIGetWorkloadCustomMetricsV1Beta', 'fromTime', fromTime)
            // verify required parameter 'toTime' is not null or undefined
            assertParamExists('workloadOptimizationAPIGetWorkloadCustomMetricsV1Beta', 'toTime', toTime)
            const localVarPath = `/v1beta/workload-autoscaling/clusters/{clusterId}/workloads/{workloadId}/custom-metrics`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"workloadId"}}`, encodeURIComponent(String(workloadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (containerName !== undefined) {
                localVarQueryParameter['containerName'] = containerName;
            }

            if (step !== undefined) {
                localVarQueryParameter['step'] = step;
            }

            if (fromTime !== undefined) {
                localVarQueryParameter['fromTime'] = (fromTime as any instanceof Date) ?
                    (fromTime as any).toISOString() :
                    fromTime;
            }

            if (toTime !== undefined) {
                localVarQueryParameter['toTime'] = (toTime as any instanceof Date) ?
                    (toTime as any).toISOString() :
                    toTime;
            }

            if (backfillDataPoints !== undefined) {
                localVarQueryParameter['backfillDataPoints'] = backfillDataPoints;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a specific workload event by the given id.
         * @param {string} clusterId The Cluster ID in which the given event happened.
         * @param {string} eventId The ID of the event.
         * @param {string} createdAt The creation time of the event.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIGetWorkloadEvent: async (clusterId: string, eventId: string, createdAt: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('workloadOptimizationAPIGetWorkloadEvent', 'clusterId', clusterId)
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('workloadOptimizationAPIGetWorkloadEvent', 'eventId', eventId)
            // verify required parameter 'createdAt' is not null or undefined
            assertParamExists('workloadOptimizationAPIGetWorkloadEvent', 'createdAt', createdAt)
            const localVarPath = `/v1/workload-autoscaling/clusters/{clusterId}/workload-events/{eventId}`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (createdAt !== undefined) {
                localVarQueryParameter['createdAt'] = (createdAt as any instanceof Date) ?
                    (createdAt as any).toISOString() :
                    createdAt;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a workload events summary for given cluster.
         * @param {string} clusterId 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {string} [workloadId] 
         * @param {string} [workloadName] 
         * @param {string} [workloadNamespace] 
         * @param {string} [workloadKind] 
         * @param {Array<WorkloadOptimizationAPIGetWorkloadEventsSummaryTypeEnum>} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIGetWorkloadEventsSummary: async (clusterId: string, fromDate?: string, toDate?: string, workloadId?: string, workloadName?: string, workloadNamespace?: string, workloadKind?: string, type?: Array<WorkloadOptimizationAPIGetWorkloadEventsSummaryTypeEnum>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('workloadOptimizationAPIGetWorkloadEventsSummary', 'clusterId', clusterId)
            const localVarPath = `/v1/workload-autoscaling/clusters/{clusterId}/workload-events-summary`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString() :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString() :
                    toDate;
            }

            if (workloadId !== undefined) {
                localVarQueryParameter['workloadId'] = workloadId;
            }

            if (workloadName !== undefined) {
                localVarQueryParameter['workloadName'] = workloadName;
            }

            if (workloadNamespace !== undefined) {
                localVarQueryParameter['workloadNamespace'] = workloadNamespace;
            }

            if (workloadKind !== undefined) {
                localVarQueryParameter['workloadKind'] = workloadKind;
            }

            if (type) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns workload filter values.
         * @param {string} clusterId 
         * @param {Array<WorkloadOptimizationAPIGetWorkloadFiltersManagementOptionsEnum>} [managementOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIGetWorkloadFilters: async (clusterId: string, managementOptions?: Array<WorkloadOptimizationAPIGetWorkloadFiltersManagementOptionsEnum>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('workloadOptimizationAPIGetWorkloadFilters', 'clusterId', clusterId)
            const localVarPath = `/v1/workload-autoscaling/clusters/{clusterId}/workloads/filters`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (managementOptions) {
                localVarQueryParameter['managementOptions'] = managementOptions;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns step-bucketed GPU utilization time-series and recommendations for a workload.
         * @param {string} clusterId 
         * @param {string} workloadId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIGetWorkloadGPUMetrics: async (clusterId: string, workloadId: string, from?: string, to?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('workloadOptimizationAPIGetWorkloadGPUMetrics', 'clusterId', clusterId)
            // verify required parameter 'workloadId' is not null or undefined
            assertParamExists('workloadOptimizationAPIGetWorkloadGPUMetrics', 'workloadId', workloadId)
            const localVarPath = `/v1/workload-autoscaling/clusters/{clusterId}/workloads/{workloadId}/gpu-metrics`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"workloadId"}}`, encodeURIComponent(String(workloadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns native VPA spec of the workload by a given id.
         * @param {string} clusterId 
         * @param {string} workloadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIGetWorkloadNativeVpaSpec: async (clusterId: string, workloadId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('workloadOptimizationAPIGetWorkloadNativeVpaSpec', 'clusterId', clusterId)
            // verify required parameter 'workloadId' is not null or undefined
            assertParamExists('workloadOptimizationAPIGetWorkloadNativeVpaSpec', 'workloadId', workloadId)
            const localVarPath = `/v1/workload-autoscaling/clusters/{clusterId}/workloads/{workloadId}/native-vpa-spec`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"workloadId"}}`, encodeURIComponent(String(workloadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the deployed Recommendation CR manifest for the workload, sourced from the latest cluster snapshot.
         * @param {string} clusterId 
         * @param {string} workloadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIGetWorkloadRecommendationManifest: async (clusterId: string, workloadId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('workloadOptimizationAPIGetWorkloadRecommendationManifest', 'clusterId', clusterId)
            // verify required parameter 'workloadId' is not null or undefined
            assertParamExists('workloadOptimizationAPIGetWorkloadRecommendationManifest', 'workloadId', workloadId)
            const localVarPath = `/v1/workload-autoscaling/clusters/{clusterId}/workloads/{workloadId}/recommendation-manifest`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"workloadId"}}`, encodeURIComponent(String(workloadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns scaling policy.
         * @param {string} clusterId 
         * @param {string} policyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIGetWorkloadScalingPolicy: async (clusterId: string, policyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('workloadOptimizationAPIGetWorkloadScalingPolicy', 'clusterId', clusterId)
            // verify required parameter 'policyId' is not null or undefined
            assertParamExists('workloadOptimizationAPIGetWorkloadScalingPolicy', 'policyId', policyId)
            const localVarPath = `/v1/workload-autoscaling/clusters/{clusterId}/policies/{policyId}`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"policyId"}}`, encodeURIComponent(String(policyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a spec of the workload by a given id.
         * @param {string} clusterId 
         * @param {string} workloadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIGetWorkloadSpec: async (clusterId: string, workloadId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('workloadOptimizationAPIGetWorkloadSpec', 'clusterId', clusterId)
            // verify required parameter 'workloadId' is not null or undefined
            assertParamExists('workloadOptimizationAPIGetWorkloadSpec', 'workloadId', workloadId)
            const localVarPath = `/v1/workload-autoscaling/clusters/{clusterId}/workloads/{workloadId}/spec`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"workloadId"}}`, encodeURIComponent(String(workloadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a workloads access context for a given cluster.
         * @param {string} clusterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIGetWorkloadsAccessContext: async (clusterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('workloadOptimizationAPIGetWorkloadsAccessContext', 'clusterId', clusterId)
            const localVarPath = `/v1/workload-autoscaling/clusters/{clusterId}/workloads-access-context`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns workloads optimization summary.
         * @param {string} clusterId 
         * @param {boolean} [includeCosts] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIGetWorkloadsSummary: async (clusterId: string, includeCosts?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('workloadOptimizationAPIGetWorkloadsSummary', 'clusterId', clusterId)
            const localVarPath = `/v1/workload-autoscaling/clusters/{clusterId}/workloads-summary`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeCosts !== undefined) {
                localVarQueryParameter['includeCosts'] = includeCosts;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns workloads summary time series.
         * @param {string} clusterId 
         * @param {string} [fromTime] 
         * @param {string} [toTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIGetWorkloadsSummaryMetrics: async (clusterId: string, fromTime?: string, toTime?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('workloadOptimizationAPIGetWorkloadsSummaryMetrics', 'clusterId', clusterId)
            const localVarPath = `/v1/workload-autoscaling/clusters/{clusterId}/workloads-summary-metrics`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fromTime !== undefined) {
                localVarQueryParameter['fromTime'] = (fromTime as any instanceof Date) ?
                    (fromTime as any).toISOString() :
                    fromTime;
            }

            if (toTime !== undefined) {
                localVarQueryParameter['toTime'] = (toTime as any instanceof Date) ?
                    (toTime as any).toISOString() :
                    toTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all HPAs configured on workloads in the given cluster, including workload context (requests, P75 usage, recommendation, current pod count) and an optional converted HPA spec produced by a named converter. The UI is expected to perform aggregation, filtering and pagination client-side.
         * @param {string} clusterId 
         * @param {Array<string>} [workloadNames] 
         * @param {Array<string>} [namespaces] 
         * @param {Array<string>} [scalingPolicyNames] 
         * @param {Array<string>} [kinds] 
         * @param {Array<WorkloadOptimizationAPIListClusterHPAsManagementOptionsEnum>} [managementOptions] 
         * @param {WorkloadOptimizationAPIListClusterHPAsIncludeConversionEnum} [includeConversion] Identifier of the HPA converter to apply to each returned HPA. When empty, no conversion is executed and the &#x60;conversion&#x60; field on each item is unset.   - AVERAGE_VALUE_FROM_ORIGINAL_REQUESTS: Converts HPA utilization (%) targets to AverageValue using workload container requests.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIListClusterHPAs: async (clusterId: string, workloadNames?: Array<string>, namespaces?: Array<string>, scalingPolicyNames?: Array<string>, kinds?: Array<string>, managementOptions?: Array<WorkloadOptimizationAPIListClusterHPAsManagementOptionsEnum>, includeConversion?: WorkloadOptimizationAPIListClusterHPAsIncludeConversionEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('workloadOptimizationAPIListClusterHPAs', 'clusterId', clusterId)
            const localVarPath = `/v1beta/workload-autoscaling/clusters/{clusterId}/hpas:analyze`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (workloadNames) {
                localVarQueryParameter['workloadNames'] = workloadNames;
            }

            if (namespaces) {
                localVarQueryParameter['namespaces'] = namespaces;
            }

            if (scalingPolicyNames) {
                localVarQueryParameter['scalingPolicyNames'] = scalingPolicyNames;
            }

            if (kinds) {
                localVarQueryParameter['kinds'] = kinds;
            }

            if (managementOptions) {
                localVarQueryParameter['managementOptions'] = managementOptions;
            }

            if (includeConversion !== undefined) {
                localVarQueryParameter['includeConversion'] = includeConversion;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a list of custom metrics data sources for given cluster.
         * @param {string} clusterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIListCustomMetricsDataSources: async (clusterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('workloadOptimizationAPIListCustomMetricsDataSources', 'clusterId', clusterId)
            const localVarPath = `/v1/workload-autoscaling/clusters/{clusterId}/custom-metrics/configs/data-sources`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a list of limit ranges for given cluster.
         * @param {string} clusterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIListLimitRanges: async (clusterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('workloadOptimizationAPIListLimitRanges', 'clusterId', clusterId)
            const localVarPath = `/v1/workload-autoscaling/clusters/{clusterId}/limit-ranges`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a list of resource quotas for given cluster.
         * @param {string} clusterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIListResourceQuotas: async (clusterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('workloadOptimizationAPIListResourceQuotas', 'clusterId', clusterId)
            const localVarPath = `/v1/workload-autoscaling/clusters/{clusterId}/resource-quotas`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a list of workload events for given cluster.
         * @param {string} clusterId 
         * @param {string} [pageLimit] 
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page. Empty value indicates to start from beginning of the dataset.
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {string} [workloadId] 
         * @param {string} [workloadName] 
         * @param {string} [workloadNamespace] 
         * @param {string} [workloadKind] 
         * @param {Array<WorkloadOptimizationAPIListWorkloadEventsTypeEnum>} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIListWorkloadEvents: async (clusterId: string, pageLimit?: string, pageCursor?: string, fromDate?: string, toDate?: string, workloadId?: string, workloadName?: string, workloadNamespace?: string, workloadKind?: string, type?: Array<WorkloadOptimizationAPIListWorkloadEventsTypeEnum>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('workloadOptimizationAPIListWorkloadEvents', 'clusterId', clusterId)
            const localVarPath = `/v1/workload-autoscaling/clusters/{clusterId}/workload-events`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString() :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString() :
                    toDate;
            }

            if (workloadId !== undefined) {
                localVarQueryParameter['workloadId'] = workloadId;
            }

            if (workloadName !== undefined) {
                localVarQueryParameter['workloadName'] = workloadName;
            }

            if (workloadNamespace !== undefined) {
                localVarQueryParameter['workloadNamespace'] = workloadNamespace;
            }

            if (workloadKind !== undefined) {
                localVarQueryParameter['workloadKind'] = workloadKind;
            }

            if (type) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a list of workload scaling policies for given cluster.
         * @param {string} clusterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIListWorkloadScalingPolicies: async (clusterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('workloadOptimizationAPIListWorkloadScalingPolicies', 'clusterId', clusterId)
            const localVarPath = `/v1/workload-autoscaling/clusters/{clusterId}/policies`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a list of workloads for the given cluster.
         * @param {string} clusterId 
         * @param {Array<string>} [workloadIds] 
         * @param {Array<string>} [workloadNames] 
         * @param {Array<string>} [namespaces] 
         * @param {Array<string>} [scalingPolicyNames] 
         * @param {Array<string>} [kinds] 
         * @param {Array<WorkloadOptimizationAPIListWorkloadsManagementOptionsEnum>} [managementOptions] 
         * @param {Array<string>} [configuredBy] 
         * @param {string} [searchQuery] 
         * @param {string} [pageLimit] 
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page. Empty value indicates to start from beginning of the dataset.
         * @param {string} [sortField] Name of the field you want to sort
         * @param {WorkloadOptimizationAPIListWorkloadsSortOrderEnum} [sortOrder] The sort order, possible values ASC or DESC, if not provided asc is the default   - ASC: ASC  - asc: desc  - DESC: ASC  - desc: desc
         * @param {WorkloadOptimizationAPIListWorkloadsRecommendationStatusTypeEnum} [recommendationStatusType] 
         * @param {boolean} [recommendationIsLowConfidence] 
         * @param {boolean} [workloadHasError] 
         * @param {boolean} [workloadHasCustomMetrics] 
         * @param {WorkloadOptimizationAPIListWorkloadsAnyContainerWithRuntimeEnum} [anyContainerWithRuntime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIListWorkloads: async (clusterId: string, workloadIds?: Array<string>, workloadNames?: Array<string>, namespaces?: Array<string>, scalingPolicyNames?: Array<string>, kinds?: Array<string>, managementOptions?: Array<WorkloadOptimizationAPIListWorkloadsManagementOptionsEnum>, configuredBy?: Array<string>, searchQuery?: string, pageLimit?: string, pageCursor?: string, sortField?: string, sortOrder?: WorkloadOptimizationAPIListWorkloadsSortOrderEnum, recommendationStatusType?: WorkloadOptimizationAPIListWorkloadsRecommendationStatusTypeEnum, recommendationIsLowConfidence?: boolean, workloadHasError?: boolean, workloadHasCustomMetrics?: boolean, anyContainerWithRuntime?: WorkloadOptimizationAPIListWorkloadsAnyContainerWithRuntimeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('workloadOptimizationAPIListWorkloads', 'clusterId', clusterId)
            const localVarPath = `/v1/workload-autoscaling/clusters/{clusterId}/workloads`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (workloadIds) {
                localVarQueryParameter['workloadIds'] = workloadIds;
            }

            if (workloadNames) {
                localVarQueryParameter['workloadNames'] = workloadNames;
            }

            if (namespaces) {
                localVarQueryParameter['namespaces'] = namespaces;
            }

            if (scalingPolicyNames) {
                localVarQueryParameter['scalingPolicyNames'] = scalingPolicyNames;
            }

            if (kinds) {
                localVarQueryParameter['kinds'] = kinds;
            }

            if (managementOptions) {
                localVarQueryParameter['managementOptions'] = managementOptions;
            }

            if (configuredBy) {
                localVarQueryParameter['configuredBy'] = configuredBy;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['searchQuery'] = searchQuery;
            }

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }

            if (sortField !== undefined) {
                localVarQueryParameter['sort.field'] = sortField;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort.order'] = sortOrder;
            }

            if (recommendationStatusType !== undefined) {
                localVarQueryParameter['recommendationStatusType'] = recommendationStatusType;
            }

            if (recommendationIsLowConfidence !== undefined) {
                localVarQueryParameter['recommendationIsLowConfidence'] = recommendationIsLowConfidence;
            }

            if (workloadHasError !== undefined) {
                localVarQueryParameter['workloadHasError'] = workloadHasError;
            }

            if (workloadHasCustomMetrics !== undefined) {
                localVarQueryParameter['workloadHasCustomMetrics'] = workloadHasCustomMetrics;
            }

            if (anyContainerWithRuntime !== undefined) {
                localVarQueryParameter['anyContainerWithRuntime'] = anyContainerWithRuntime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Migrates all eligible cluster workloads to HPA v2
         * @param {string} clusterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIMigrateClusterToHPAV2: async (clusterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('workloadOptimizationAPIMigrateClusterToHPAV2', 'clusterId', clusterId)
            const localVarPath = `/v1/workload-autoscaling/clusters/{clusterId}/workloads/migrate-to-hpa-v2`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Partially updates a scaling policy. Only fields covered by the update mask are modified; all other fields keep their current values.
         * @param {string} clusterId 
         * @param {string} policyId 
         * @param {WorkloadOptimizationAPIPatchWorkloadScalingPolicyRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIPatchWorkloadScalingPolicy: async (clusterId: string, policyId: string, body: WorkloadOptimizationAPIPatchWorkloadScalingPolicyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('workloadOptimizationAPIPatchWorkloadScalingPolicy', 'clusterId', clusterId)
            // verify required parameter 'policyId' is not null or undefined
            assertParamExists('workloadOptimizationAPIPatchWorkloadScalingPolicy', 'policyId', policyId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('workloadOptimizationAPIPatchWorkloadScalingPolicy', 'body', body)
            const localVarPath = `/v1/workload-autoscaling/clusters/{clusterId}/policies/{policyId}`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"policyId"}}`, encodeURIComponent(String(policyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates a CAST AI managed workload V2 partially using field mask.
         * @param {string} clusterId 
         * @param {string} workloadId 
         * @param {WorkloadOptimizationAPIPatchWorkloadV2Request} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIPatchWorkloadV2: async (clusterId: string, workloadId: string, body: WorkloadOptimizationAPIPatchWorkloadV2Request, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('workloadOptimizationAPIPatchWorkloadV2', 'clusterId', clusterId)
            // verify required parameter 'workloadId' is not null or undefined
            assertParamExists('workloadOptimizationAPIPatchWorkloadV2', 'workloadId', workloadId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('workloadOptimizationAPIPatchWorkloadV2', 'body', body)
            const localVarPath = `/v2/workload-autoscaling/clusters/{clusterId}/workloads/{workloadId}`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"workloadId"}}`, encodeURIComponent(String(workloadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Query workload metrics time series.
         * @param {string} clusterId 
         * @param {WorkloadOptimizationAPIQueryWorkloadMetricsRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIQueryWorkloadMetrics: async (clusterId: string, body: WorkloadOptimizationAPIQueryWorkloadMetricsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('workloadOptimizationAPIQueryWorkloadMetrics', 'clusterId', clusterId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('workloadOptimizationAPIQueryWorkloadMetrics', 'body', body)
            const localVarPath = `/v1alpha/workload-autoscaling/clusters/{clusterId}/workloads/metrics:query`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resets the system overrides for a workload.
         * @param {string} clusterId 
         * @param {string} workloadId 
         * @param {WorkloadOptimizationAPIResetSystemOverridesRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIResetSystemOverrides: async (clusterId: string, workloadId: string, body: WorkloadOptimizationAPIResetSystemOverridesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('workloadOptimizationAPIResetSystemOverrides', 'clusterId', clusterId)
            // verify required parameter 'workloadId' is not null or undefined
            assertParamExists('workloadOptimizationAPIResetSystemOverrides', 'workloadId', workloadId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('workloadOptimizationAPIResetSystemOverrides', 'body', body)
            const localVarPath = `/v1/workload-autoscaling/clusters/{clusterId}/workloads/{workloadId}/system-overrides:reset`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"workloadId"}}`, encodeURIComponent(String(workloadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Determines the order in which policies are applied to workloads based on assignment rules. By default, policies are sorted by their creation timestamp (CreatedAt).  You MUST provide the complete list of policy IDs in the exact order they should be applied.
         * @summary Updates the order of scaling policies for a given cluster.
         * @param {string} clusterId 
         * @param {WorkloadOptimizationAPISetScalingPoliciesOrderRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPISetScalingPoliciesOrder: async (clusterId: string, body: WorkloadOptimizationAPISetScalingPoliciesOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('workloadOptimizationAPISetScalingPoliciesOrder', 'clusterId', clusterId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('workloadOptimizationAPISetScalingPoliciesOrder', 'body', body)
            const localVarPath = `/v1/workload-autoscaling/clusters/{clusterId}/policies/order`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary SyncSystemPolicyAssignmentRules syncs assignment rules from system scaling policies to target clusters. This is an internal-only endpoint used by the admin service.
         * @param {string} organizationId 
         * @param {WorkloadOptimizationAPISyncSystemPolicyAssignmentRulesRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPISyncSystemPolicyAssignmentRules: async (organizationId: string, body: WorkloadOptimizationAPISyncSystemPolicyAssignmentRulesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('workloadOptimizationAPISyncSystemPolicyAssignmentRules', 'organizationId', organizationId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('workloadOptimizationAPISyncSystemPolicyAssignmentRules', 'body', body)
            const localVarPath = `/v1/workload-autoscaling/organizations/{organizationId}/scaling-policies/assignment-rules:sync`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates a custom metrics data source.
         * @param {string} clusterId The cluster ID that owns this custom metrics data source.
         * @param {string} id The ID of the custom metrics data source to update.
         * @param {WorkloadOptimizationAPIUpdateCustomMetricsDataSourceRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIUpdateCustomMetricsDataSource: async (clusterId: string, id: string, body: WorkloadOptimizationAPIUpdateCustomMetricsDataSourceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('workloadOptimizationAPIUpdateCustomMetricsDataSource', 'clusterId', clusterId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('workloadOptimizationAPIUpdateCustomMetricsDataSource', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('workloadOptimizationAPIUpdateCustomMetricsDataSource', 'body', body)
            const localVarPath = `/v1/workload-autoscaling/clusters/{clusterId}/custom-metrics/configs/data-sources/{id}`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates a scaling policy.
         * @param {string} clusterId Cluster ID associated with the scaling policy.
         * @param {string} policyId Policy ID associated with the scaling policy.
         * @param {WorkloadoptimizationV1UpdateWorkloadScalingPolicy} policy The values to configure for the policy.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIUpdateWorkloadScalingPolicy: async (clusterId: string, policyId: string, policy: WorkloadoptimizationV1UpdateWorkloadScalingPolicy, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('workloadOptimizationAPIUpdateWorkloadScalingPolicy', 'clusterId', clusterId)
            // verify required parameter 'policyId' is not null or undefined
            assertParamExists('workloadOptimizationAPIUpdateWorkloadScalingPolicy', 'policyId', policyId)
            // verify required parameter 'policy' is not null or undefined
            assertParamExists('workloadOptimizationAPIUpdateWorkloadScalingPolicy', 'policy', policy)
            const localVarPath = `/v1/workload-autoscaling/clusters/{clusterId}/policies/{policyId}`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"policyId"}}`, encodeURIComponent(String(policyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(policy, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates a CAST AI managed workload V2.
         * @param {string} clusterId 
         * @param {string} workloadId 
         * @param {WorkloadoptimizationV1UpdateWorkloadV2} workload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIUpdateWorkloadV2: async (clusterId: string, workloadId: string, workload: WorkloadoptimizationV1UpdateWorkloadV2, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('workloadOptimizationAPIUpdateWorkloadV2', 'clusterId', clusterId)
            // verify required parameter 'workloadId' is not null or undefined
            assertParamExists('workloadOptimizationAPIUpdateWorkloadV2', 'workloadId', workloadId)
            // verify required parameter 'workload' is not null or undefined
            assertParamExists('workloadOptimizationAPIUpdateWorkloadV2', 'workload', workload)
            const localVarPath = `/v2/workload-autoscaling/clusters/{clusterId}/workloads/{workloadId}`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"workloadId"}}`, encodeURIComponent(String(workloadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkloadOptimizationAPIApi - functional programming interface
 * @export
 */
export const WorkloadOptimizationAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkloadOptimizationAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Assigns the provided list of workload IDs to the specified policy.
         * @param {string} clusterId Cluster ID associated with the scaling policy.
         * @param {string} policyId Policy ID associated with the scaling policy.
         * @param {WorkloadOptimizationAPIAssignScalingPolicyWorkloadsRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workloadOptimizationAPIAssignScalingPolicyWorkloads(clusterId: string, policyId: string, body: WorkloadOptimizationAPIAssignScalingPolicyWorkloadsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workloadOptimizationAPIAssignScalingPolicyWorkloads(clusterId, policyId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkloadOptimizationAPIApi.workloadOptimizationAPIAssignScalingPolicyWorkloads']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Creates a custom metrics data source for given cluster.
         * @param {string} clusterId 
         * @param {WorkloadoptimizationV1NewCustomMetricsDataSource} dataSource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workloadOptimizationAPICreateCustomMetricsDataSource(clusterId: string, dataSource: WorkloadoptimizationV1NewCustomMetricsDataSource, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkloadoptimizationV1CustomMetricsDataSource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workloadOptimizationAPICreateCustomMetricsDataSource(clusterId, dataSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkloadOptimizationAPIApi.workloadOptimizationAPICreateCustomMetricsDataSource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Creates a scaling policy that can be assigned to workloads at a later time.
         * @param {string} clusterId 
         * @param {WorkloadoptimizationV1NewWorkloadScalingPolicy} policy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workloadOptimizationAPICreateWorkloadScalingPolicy(clusterId: string, policy: WorkloadoptimizationV1NewWorkloadScalingPolicy, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkloadoptimizationV1WorkloadScalingPolicy>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workloadOptimizationAPICreateWorkloadScalingPolicy(clusterId, policy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkloadOptimizationAPIApi.workloadOptimizationAPICreateWorkloadScalingPolicy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Deletes a custom metrics data source.
         * @param {string} clusterId The cluster ID that owns this custom metrics data source.
         * @param {string} id The ID of the custom metrics data source to delete.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workloadOptimizationAPIDeleteCustomMetricsDataSource(clusterId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workloadOptimizationAPIDeleteCustomMetricsDataSource(clusterId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkloadOptimizationAPIApi.workloadOptimizationAPIDeleteCustomMetricsDataSource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Deletes a scaling policy.
         * @param {string} clusterId 
         * @param {string} policyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workloadOptimizationAPIDeleteWorkloadScalingPolicy(clusterId: string, policyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workloadOptimizationAPIDeleteWorkloadScalingPolicy(clusterId, policyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkloadOptimizationAPIApi.workloadOptimizationAPIDeleteWorkloadScalingPolicy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary DisableCluster temporarily disables workload optimization for a cluster. This is an internal-only endpoint used by the admin service.
         * @param {string} clusterId 
         * @param {WorkloadOptimizationAPIDisableClusterRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workloadOptimizationAPIDisableCluster(clusterId: string, body: WorkloadOptimizationAPIDisableClusterRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkloadoptimizationV1DisableClusterResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workloadOptimizationAPIDisableCluster(clusterId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkloadOptimizationAPIApi.workloadOptimizationAPIDisableCluster']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary EnableCluster re-enables workload optimization for a temporarily disabled cluster. This is an internal-only endpoint used by the admin service.
         * @param {string} clusterId 
         * @param {WorkloadOptimizationAPIEnableClusterRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workloadOptimizationAPIEnableCluster(clusterId: string, body: WorkloadOptimizationAPIEnableClusterRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workloadOptimizationAPIEnableCluster(clusterId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkloadOptimizationAPIApi.workloadOptimizationAPIEnableCluster']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Requests generation of recommendation for a workload
         * @param {string} clusterId 
         * @param {string} workloadId 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workloadOptimizationAPIGenerateRecommendation(clusterId: string, workloadId: string, body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workloadOptimizationAPIGenerateRecommendation(clusterId, workloadId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkloadOptimizationAPIApi.workloadOptimizationAPIGenerateRecommendation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns the adoption-weighted CPU billing metric for the given organization+cluster+window.
         * @param {string} clusterId The cluster within the organization. Required, must be a valid UUID.
         * @param {string} organizationId The organization for which to compute the metric. Required, must be a valid UUID.
         * @param {string} from Inclusive start of the billing window. Required. Must be in the past and within the last 60 days (matches the workloads_summary TTL). Handler also enforces from &lt; to and (to - from) &lt;&#x3D; 30 days.
         * @param {string} to Exclusive end of the billing window. Required. Must be in the past and within the last 60 days (matches the workloads_summary TTL). Handler also enforces from &lt; to and (to - from) &lt;&#x3D; 30 days.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workloadOptimizationAPIGetAdoptionWeightedCPU(clusterId: string, organizationId: string, from: string, to: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkloadoptimizationV1GetAdoptionWeightedCPUResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workloadOptimizationAPIGetAdoptionWeightedCPU(clusterId, organizationId, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkloadOptimizationAPIApi.workloadOptimizationAPIGetAdoptionWeightedCPU']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns status of workload-autoscaler agent.
         * @param {string} clusterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workloadOptimizationAPIGetAgentStatus(clusterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkloadoptimizationV1GetAgentStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workloadOptimizationAPIGetAgentStatus(clusterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkloadOptimizationAPIApi.workloadOptimizationAPIGetAgentStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary GetAggregatedWorkloadCustomMetrics returns aggregated custom metrics time-series data. Pods are aggregated across the workload, grouped by metric name and container.
         * @param {string} clusterId 
         * @param {string} workloadId 
         * @param {string} containerName 
         * @param {string} fromTime 
         * @param {string} toTime 
         * @param {string} aggregationSlidingWindow Sliding window duration for aggregation (e.g. 30 minutes).
         * @param {WorkloadOptimizationAPIGetAggregatedWorkloadCustomMetricsV1BetaAggregationTypeEnum} aggregationType 
         * @param {string} [step] Sampling interval for metrics. The server may enforce a step even when one is not provided, or change it if it\&#39;s too short. The actual step used is returned in the response.
         * @param {number} [aggregationPercentile] Only used when type is PERCENTILE (e.g. 95 for p95).
         * @param {boolean} [backfillDataPoints] When true, missing data points in the time range are backfilled with null values at each step interval.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workloadOptimizationAPIGetAggregatedWorkloadCustomMetricsV1Beta(clusterId: string, workloadId: string, containerName: string, fromTime: string, toTime: string, aggregationSlidingWindow: string, aggregationType: WorkloadOptimizationAPIGetAggregatedWorkloadCustomMetricsV1BetaAggregationTypeEnum, step?: string, aggregationPercentile?: number, backfillDataPoints?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkloadoptimizationV1GetAggregatedWorkloadCustomMetricsV1BetaResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workloadOptimizationAPIGetAggregatedWorkloadCustomMetricsV1Beta(clusterId, workloadId, containerName, fromTime, toTime, aggregationSlidingWindow, aggregationType, step, aggregationPercentile, backfillDataPoints, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkloadOptimizationAPIApi.workloadOptimizationAPIGetAggregatedWorkloadCustomMetricsV1Beta']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns HPA v2 migration eligibility for a cluster
         * @param {string} clusterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workloadOptimizationAPIGetHPAV2MigrationEligibility(clusterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkloadoptimizationV1GetHPAV2MigrationEligibilityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workloadOptimizationAPIGetHPAV2MigrationEligibility(clusterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkloadOptimizationAPIApi.workloadOptimizationAPIGetHPAV2MigrationEligibility']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns status of workload-autoscaler agents for all clusters in an organization.
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workloadOptimizationAPIGetOrganizationAgentStatuses(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkloadoptimizationV1GetOrganizationAgentStatusesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workloadOptimizationAPIGetOrganizationAgentStatuses(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkloadOptimizationAPIApi.workloadOptimizationAPIGetOrganizationAgentStatuses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns a workload by a given id.
         * @param {string} clusterId 
         * @param {string} workloadId 
         * @param {boolean} [includeMetrics] 
         * @param {boolean} [includeCosts] 
         * @param {string} [fromTime] 
         * @param {string} [toTime] 
         * @param {string} [scopeValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workloadOptimizationAPIGetWorkload(clusterId: string, workloadId: string, includeMetrics?: boolean, includeCosts?: boolean, fromTime?: string, toTime?: string, scopeValue?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkloadoptimizationV1GetWorkloadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workloadOptimizationAPIGetWorkload(clusterId, workloadId, includeMetrics, includeCosts, fromTime, toTime, scopeValue, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkloadOptimizationAPIApi.workloadOptimizationAPIGetWorkload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns raw custom metrics time-series data for a workload.
         * @param {string} clusterId 
         * @param {string} workloadId 
         * @param {string} containerName 
         * @param {string} fromTime 
         * @param {string} toTime 
         * @param {string} [step] Sampling interval for metrics. For long time ranges, the server may enforce a step even if one is not provided. The actual step used is returned in the response.
         * @param {boolean} [backfillDataPoints] When true, missing data points in the time range are backfilled with null values at each step interval. Requires a step to be in effect (explicitly requested or server-calculated). Ignored when no step applies.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workloadOptimizationAPIGetWorkloadCustomMetricsV1Beta(clusterId: string, workloadId: string, containerName: string, fromTime: string, toTime: string, step?: string, backfillDataPoints?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkloadoptimizationV1GetWorkloadCustomMetricsV1BetaResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workloadOptimizationAPIGetWorkloadCustomMetricsV1Beta(clusterId, workloadId, containerName, fromTime, toTime, step, backfillDataPoints, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkloadOptimizationAPIApi.workloadOptimizationAPIGetWorkloadCustomMetricsV1Beta']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns a specific workload event by the given id.
         * @param {string} clusterId The Cluster ID in which the given event happened.
         * @param {string} eventId The ID of the event.
         * @param {string} createdAt The creation time of the event.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workloadOptimizationAPIGetWorkloadEvent(clusterId: string, eventId: string, createdAt: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkloadoptimizationV1GetWorkloadEventResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workloadOptimizationAPIGetWorkloadEvent(clusterId, eventId, createdAt, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkloadOptimizationAPIApi.workloadOptimizationAPIGetWorkloadEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns a workload events summary for given cluster.
         * @param {string} clusterId 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {string} [workloadId] 
         * @param {string} [workloadName] 
         * @param {string} [workloadNamespace] 
         * @param {string} [workloadKind] 
         * @param {Array<WorkloadOptimizationAPIGetWorkloadEventsSummaryTypeEnum>} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workloadOptimizationAPIGetWorkloadEventsSummary(clusterId: string, fromDate?: string, toDate?: string, workloadId?: string, workloadName?: string, workloadNamespace?: string, workloadKind?: string, type?: Array<WorkloadOptimizationAPIGetWorkloadEventsSummaryTypeEnum>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkloadoptimizationV1GetWorkloadEventsSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workloadOptimizationAPIGetWorkloadEventsSummary(clusterId, fromDate, toDate, workloadId, workloadName, workloadNamespace, workloadKind, type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkloadOptimizationAPIApi.workloadOptimizationAPIGetWorkloadEventsSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns workload filter values.
         * @param {string} clusterId 
         * @param {Array<WorkloadOptimizationAPIGetWorkloadFiltersManagementOptionsEnum>} [managementOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workloadOptimizationAPIGetWorkloadFilters(clusterId: string, managementOptions?: Array<WorkloadOptimizationAPIGetWorkloadFiltersManagementOptionsEnum>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkloadoptimizationV1GetWorkloadFiltersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workloadOptimizationAPIGetWorkloadFilters(clusterId, managementOptions, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkloadOptimizationAPIApi.workloadOptimizationAPIGetWorkloadFilters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns step-bucketed GPU utilization time-series and recommendations for a workload.
         * @param {string} clusterId 
         * @param {string} workloadId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workloadOptimizationAPIGetWorkloadGPUMetrics(clusterId: string, workloadId: string, from?: string, to?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkloadoptimizationV1GetWorkloadGPUMetricsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workloadOptimizationAPIGetWorkloadGPUMetrics(clusterId, workloadId, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkloadOptimizationAPIApi.workloadOptimizationAPIGetWorkloadGPUMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns native VPA spec of the workload by a given id.
         * @param {string} clusterId 
         * @param {string} workloadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workloadOptimizationAPIGetWorkloadNativeVpaSpec(clusterId: string, workloadId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkloadoptimizationV1GetWorkloadNativeVpaSpecResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workloadOptimizationAPIGetWorkloadNativeVpaSpec(clusterId, workloadId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkloadOptimizationAPIApi.workloadOptimizationAPIGetWorkloadNativeVpaSpec']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns the deployed Recommendation CR manifest for the workload, sourced from the latest cluster snapshot.
         * @param {string} clusterId 
         * @param {string} workloadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workloadOptimizationAPIGetWorkloadRecommendationManifest(clusterId: string, workloadId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkloadoptimizationV1GetWorkloadRecommendationManifestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workloadOptimizationAPIGetWorkloadRecommendationManifest(clusterId, workloadId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkloadOptimizationAPIApi.workloadOptimizationAPIGetWorkloadRecommendationManifest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns scaling policy.
         * @param {string} clusterId 
         * @param {string} policyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workloadOptimizationAPIGetWorkloadScalingPolicy(clusterId: string, policyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkloadoptimizationV1WorkloadScalingPolicy>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workloadOptimizationAPIGetWorkloadScalingPolicy(clusterId, policyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkloadOptimizationAPIApi.workloadOptimizationAPIGetWorkloadScalingPolicy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns a spec of the workload by a given id.
         * @param {string} clusterId 
         * @param {string} workloadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workloadOptimizationAPIGetWorkloadSpec(clusterId: string, workloadId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkloadoptimizationV1GetWorkloadSpecResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workloadOptimizationAPIGetWorkloadSpec(clusterId, workloadId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkloadOptimizationAPIApi.workloadOptimizationAPIGetWorkloadSpec']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns a workloads access context for a given cluster.
         * @param {string} clusterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workloadOptimizationAPIGetWorkloadsAccessContext(clusterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkloadoptimizationV1GetWorkloadsAccessContextResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workloadOptimizationAPIGetWorkloadsAccessContext(clusterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkloadOptimizationAPIApi.workloadOptimizationAPIGetWorkloadsAccessContext']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns workloads optimization summary.
         * @param {string} clusterId 
         * @param {boolean} [includeCosts] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workloadOptimizationAPIGetWorkloadsSummary(clusterId: string, includeCosts?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkloadoptimizationV1GetWorkloadsSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workloadOptimizationAPIGetWorkloadsSummary(clusterId, includeCosts, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkloadOptimizationAPIApi.workloadOptimizationAPIGetWorkloadsSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns workloads summary time series.
         * @param {string} clusterId 
         * @param {string} [fromTime] 
         * @param {string} [toTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workloadOptimizationAPIGetWorkloadsSummaryMetrics(clusterId: string, fromTime?: string, toTime?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkloadoptimizationV1GetWorkloadsSummaryMetricsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workloadOptimizationAPIGetWorkloadsSummaryMetrics(clusterId, fromTime, toTime, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkloadOptimizationAPIApi.workloadOptimizationAPIGetWorkloadsSummaryMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns all HPAs configured on workloads in the given cluster, including workload context (requests, P75 usage, recommendation, current pod count) and an optional converted HPA spec produced by a named converter. The UI is expected to perform aggregation, filtering and pagination client-side.
         * @param {string} clusterId 
         * @param {Array<string>} [workloadNames] 
         * @param {Array<string>} [namespaces] 
         * @param {Array<string>} [scalingPolicyNames] 
         * @param {Array<string>} [kinds] 
         * @param {Array<WorkloadOptimizationAPIListClusterHPAsManagementOptionsEnum>} [managementOptions] 
         * @param {WorkloadOptimizationAPIListClusterHPAsIncludeConversionEnum} [includeConversion] Identifier of the HPA converter to apply to each returned HPA. When empty, no conversion is executed and the &#x60;conversion&#x60; field on each item is unset.   - AVERAGE_VALUE_FROM_ORIGINAL_REQUESTS: Converts HPA utilization (%) targets to AverageValue using workload container requests.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workloadOptimizationAPIListClusterHPAs(clusterId: string, workloadNames?: Array<string>, namespaces?: Array<string>, scalingPolicyNames?: Array<string>, kinds?: Array<string>, managementOptions?: Array<WorkloadOptimizationAPIListClusterHPAsManagementOptionsEnum>, includeConversion?: WorkloadOptimizationAPIListClusterHPAsIncludeConversionEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkloadoptimizationV1ListClusterHPAsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workloadOptimizationAPIListClusterHPAs(clusterId, workloadNames, namespaces, scalingPolicyNames, kinds, managementOptions, includeConversion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkloadOptimizationAPIApi.workloadOptimizationAPIListClusterHPAs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns a list of custom metrics data sources for given cluster.
         * @param {string} clusterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workloadOptimizationAPIListCustomMetricsDataSources(clusterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkloadoptimizationV1ListCustomMetricsDataSourcesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workloadOptimizationAPIListCustomMetricsDataSources(clusterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkloadOptimizationAPIApi.workloadOptimizationAPIListCustomMetricsDataSources']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns a list of limit ranges for given cluster.
         * @param {string} clusterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workloadOptimizationAPIListLimitRanges(clusterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkloadoptimizationV1ListLimitRangesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workloadOptimizationAPIListLimitRanges(clusterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkloadOptimizationAPIApi.workloadOptimizationAPIListLimitRanges']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns a list of resource quotas for given cluster.
         * @param {string} clusterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workloadOptimizationAPIListResourceQuotas(clusterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkloadoptimizationV1ListResourceQuotasResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workloadOptimizationAPIListResourceQuotas(clusterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkloadOptimizationAPIApi.workloadOptimizationAPIListResourceQuotas']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns a list of workload events for given cluster.
         * @param {string} clusterId 
         * @param {string} [pageLimit] 
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page. Empty value indicates to start from beginning of the dataset.
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {string} [workloadId] 
         * @param {string} [workloadName] 
         * @param {string} [workloadNamespace] 
         * @param {string} [workloadKind] 
         * @param {Array<WorkloadOptimizationAPIListWorkloadEventsTypeEnum>} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workloadOptimizationAPIListWorkloadEvents(clusterId: string, pageLimit?: string, pageCursor?: string, fromDate?: string, toDate?: string, workloadId?: string, workloadName?: string, workloadNamespace?: string, workloadKind?: string, type?: Array<WorkloadOptimizationAPIListWorkloadEventsTypeEnum>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkloadoptimizationV1ListWorkloadEventsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workloadOptimizationAPIListWorkloadEvents(clusterId, pageLimit, pageCursor, fromDate, toDate, workloadId, workloadName, workloadNamespace, workloadKind, type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkloadOptimizationAPIApi.workloadOptimizationAPIListWorkloadEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns a list of workload scaling policies for given cluster.
         * @param {string} clusterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workloadOptimizationAPIListWorkloadScalingPolicies(clusterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkloadoptimizationV1ListWorkloadScalingPoliciesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workloadOptimizationAPIListWorkloadScalingPolicies(clusterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkloadOptimizationAPIApi.workloadOptimizationAPIListWorkloadScalingPolicies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns a list of workloads for the given cluster.
         * @param {string} clusterId 
         * @param {Array<string>} [workloadIds] 
         * @param {Array<string>} [workloadNames] 
         * @param {Array<string>} [namespaces] 
         * @param {Array<string>} [scalingPolicyNames] 
         * @param {Array<string>} [kinds] 
         * @param {Array<WorkloadOptimizationAPIListWorkloadsManagementOptionsEnum>} [managementOptions] 
         * @param {Array<string>} [configuredBy] 
         * @param {string} [searchQuery] 
         * @param {string} [pageLimit] 
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page. Empty value indicates to start from beginning of the dataset.
         * @param {string} [sortField] Name of the field you want to sort
         * @param {WorkloadOptimizationAPIListWorkloadsSortOrderEnum} [sortOrder] The sort order, possible values ASC or DESC, if not provided asc is the default   - ASC: ASC  - asc: desc  - DESC: ASC  - desc: desc
         * @param {WorkloadOptimizationAPIListWorkloadsRecommendationStatusTypeEnum} [recommendationStatusType] 
         * @param {boolean} [recommendationIsLowConfidence] 
         * @param {boolean} [workloadHasError] 
         * @param {boolean} [workloadHasCustomMetrics] 
         * @param {WorkloadOptimizationAPIListWorkloadsAnyContainerWithRuntimeEnum} [anyContainerWithRuntime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workloadOptimizationAPIListWorkloads(clusterId: string, workloadIds?: Array<string>, workloadNames?: Array<string>, namespaces?: Array<string>, scalingPolicyNames?: Array<string>, kinds?: Array<string>, managementOptions?: Array<WorkloadOptimizationAPIListWorkloadsManagementOptionsEnum>, configuredBy?: Array<string>, searchQuery?: string, pageLimit?: string, pageCursor?: string, sortField?: string, sortOrder?: WorkloadOptimizationAPIListWorkloadsSortOrderEnum, recommendationStatusType?: WorkloadOptimizationAPIListWorkloadsRecommendationStatusTypeEnum, recommendationIsLowConfidence?: boolean, workloadHasError?: boolean, workloadHasCustomMetrics?: boolean, anyContainerWithRuntime?: WorkloadOptimizationAPIListWorkloadsAnyContainerWithRuntimeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkloadoptimizationV1ListWorkloadsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workloadOptimizationAPIListWorkloads(clusterId, workloadIds, workloadNames, namespaces, scalingPolicyNames, kinds, managementOptions, configuredBy, searchQuery, pageLimit, pageCursor, sortField, sortOrder, recommendationStatusType, recommendationIsLowConfidence, workloadHasError, workloadHasCustomMetrics, anyContainerWithRuntime, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkloadOptimizationAPIApi.workloadOptimizationAPIListWorkloads']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Migrates all eligible cluster workloads to HPA v2
         * @param {string} clusterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workloadOptimizationAPIMigrateClusterToHPAV2(clusterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workloadOptimizationAPIMigrateClusterToHPAV2(clusterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkloadOptimizationAPIApi.workloadOptimizationAPIMigrateClusterToHPAV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Partially updates a scaling policy. Only fields covered by the update mask are modified; all other fields keep their current values.
         * @param {string} clusterId 
         * @param {string} policyId 
         * @param {WorkloadOptimizationAPIPatchWorkloadScalingPolicyRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workloadOptimizationAPIPatchWorkloadScalingPolicy(clusterId: string, policyId: string, body: WorkloadOptimizationAPIPatchWorkloadScalingPolicyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkloadoptimizationV1WorkloadScalingPolicy>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workloadOptimizationAPIPatchWorkloadScalingPolicy(clusterId, policyId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkloadOptimizationAPIApi.workloadOptimizationAPIPatchWorkloadScalingPolicy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates a CAST AI managed workload V2 partially using field mask.
         * @param {string} clusterId 
         * @param {string} workloadId 
         * @param {WorkloadOptimizationAPIPatchWorkloadV2Request} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workloadOptimizationAPIPatchWorkloadV2(clusterId: string, workloadId: string, body: WorkloadOptimizationAPIPatchWorkloadV2Request, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkloadoptimizationV1UpdateWorkloadResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workloadOptimizationAPIPatchWorkloadV2(clusterId, workloadId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkloadOptimizationAPIApi.workloadOptimizationAPIPatchWorkloadV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Query workload metrics time series.
         * @param {string} clusterId 
         * @param {WorkloadOptimizationAPIQueryWorkloadMetricsRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workloadOptimizationAPIQueryWorkloadMetrics(clusterId: string, body: WorkloadOptimizationAPIQueryWorkloadMetricsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkloadoptimizationV1QueryWorkloadMetricsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workloadOptimizationAPIQueryWorkloadMetrics(clusterId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkloadOptimizationAPIApi.workloadOptimizationAPIQueryWorkloadMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Resets the system overrides for a workload.
         * @param {string} clusterId 
         * @param {string} workloadId 
         * @param {WorkloadOptimizationAPIResetSystemOverridesRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workloadOptimizationAPIResetSystemOverrides(clusterId: string, workloadId: string, body: WorkloadOptimizationAPIResetSystemOverridesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkloadoptimizationV1ResetSystemOverridesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workloadOptimizationAPIResetSystemOverrides(clusterId, workloadId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkloadOptimizationAPIApi.workloadOptimizationAPIResetSystemOverrides']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Determines the order in which policies are applied to workloads based on assignment rules. By default, policies are sorted by their creation timestamp (CreatedAt).  You MUST provide the complete list of policy IDs in the exact order they should be applied.
         * @summary Updates the order of scaling policies for a given cluster.
         * @param {string} clusterId 
         * @param {WorkloadOptimizationAPISetScalingPoliciesOrderRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workloadOptimizationAPISetScalingPoliciesOrder(clusterId: string, body: WorkloadOptimizationAPISetScalingPoliciesOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workloadOptimizationAPISetScalingPoliciesOrder(clusterId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkloadOptimizationAPIApi.workloadOptimizationAPISetScalingPoliciesOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary SyncSystemPolicyAssignmentRules syncs assignment rules from system scaling policies to target clusters. This is an internal-only endpoint used by the admin service.
         * @param {string} organizationId 
         * @param {WorkloadOptimizationAPISyncSystemPolicyAssignmentRulesRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workloadOptimizationAPISyncSystemPolicyAssignmentRules(organizationId: string, body: WorkloadOptimizationAPISyncSystemPolicyAssignmentRulesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkloadoptimizationV1SyncSystemPolicyAssignmentRulesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workloadOptimizationAPISyncSystemPolicyAssignmentRules(organizationId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkloadOptimizationAPIApi.workloadOptimizationAPISyncSystemPolicyAssignmentRules']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates a custom metrics data source.
         * @param {string} clusterId The cluster ID that owns this custom metrics data source.
         * @param {string} id The ID of the custom metrics data source to update.
         * @param {WorkloadOptimizationAPIUpdateCustomMetricsDataSourceRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workloadOptimizationAPIUpdateCustomMetricsDataSource(clusterId: string, id: string, body: WorkloadOptimizationAPIUpdateCustomMetricsDataSourceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkloadoptimizationV1CustomMetricsDataSource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workloadOptimizationAPIUpdateCustomMetricsDataSource(clusterId, id, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkloadOptimizationAPIApi.workloadOptimizationAPIUpdateCustomMetricsDataSource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates a scaling policy.
         * @param {string} clusterId Cluster ID associated with the scaling policy.
         * @param {string} policyId Policy ID associated with the scaling policy.
         * @param {WorkloadoptimizationV1UpdateWorkloadScalingPolicy} policy The values to configure for the policy.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workloadOptimizationAPIUpdateWorkloadScalingPolicy(clusterId: string, policyId: string, policy: WorkloadoptimizationV1UpdateWorkloadScalingPolicy, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkloadoptimizationV1WorkloadScalingPolicy>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workloadOptimizationAPIUpdateWorkloadScalingPolicy(clusterId, policyId, policy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkloadOptimizationAPIApi.workloadOptimizationAPIUpdateWorkloadScalingPolicy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates a CAST AI managed workload V2.
         * @param {string} clusterId 
         * @param {string} workloadId 
         * @param {WorkloadoptimizationV1UpdateWorkloadV2} workload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workloadOptimizationAPIUpdateWorkloadV2(clusterId: string, workloadId: string, workload: WorkloadoptimizationV1UpdateWorkloadV2, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkloadoptimizationV1UpdateWorkloadResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workloadOptimizationAPIUpdateWorkloadV2(clusterId, workloadId, workload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkloadOptimizationAPIApi.workloadOptimizationAPIUpdateWorkloadV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WorkloadOptimizationAPIApi - factory interface
 * @export
 */
export const WorkloadOptimizationAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkloadOptimizationAPIApiFp(configuration)
    return {
        /**
         * 
         * @summary Assigns the provided list of workload IDs to the specified policy.
         * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIAssignScalingPolicyWorkloadsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIAssignScalingPolicyWorkloads(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIAssignScalingPolicyWorkloadsRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.workloadOptimizationAPIAssignScalingPolicyWorkloads(requestParameters.clusterId, requestParameters.policyId, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates a custom metrics data source for given cluster.
         * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPICreateCustomMetricsDataSourceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPICreateCustomMetricsDataSource(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPICreateCustomMetricsDataSourceRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkloadoptimizationV1CustomMetricsDataSource> {
            return localVarFp.workloadOptimizationAPICreateCustomMetricsDataSource(requestParameters.clusterId, requestParameters.dataSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates a scaling policy that can be assigned to workloads at a later time.
         * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPICreateWorkloadScalingPolicyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPICreateWorkloadScalingPolicy(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPICreateWorkloadScalingPolicyRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkloadoptimizationV1WorkloadScalingPolicy> {
            return localVarFp.workloadOptimizationAPICreateWorkloadScalingPolicy(requestParameters.clusterId, requestParameters.policy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes a custom metrics data source.
         * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIDeleteCustomMetricsDataSourceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIDeleteCustomMetricsDataSource(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIDeleteCustomMetricsDataSourceRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.workloadOptimizationAPIDeleteCustomMetricsDataSource(requestParameters.clusterId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes a scaling policy.
         * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIDeleteWorkloadScalingPolicyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIDeleteWorkloadScalingPolicy(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIDeleteWorkloadScalingPolicyRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.workloadOptimizationAPIDeleteWorkloadScalingPolicy(requestParameters.clusterId, requestParameters.policyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary DisableCluster temporarily disables workload optimization for a cluster. This is an internal-only endpoint used by the admin service.
         * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIDisableClusterRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIDisableCluster(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIDisableClusterRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkloadoptimizationV1DisableClusterResponse> {
            return localVarFp.workloadOptimizationAPIDisableCluster(requestParameters.clusterId, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary EnableCluster re-enables workload optimization for a temporarily disabled cluster. This is an internal-only endpoint used by the admin service.
         * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIEnableClusterRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIEnableCluster(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIEnableClusterRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.workloadOptimizationAPIEnableCluster(requestParameters.clusterId, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Requests generation of recommendation for a workload
         * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIGenerateRecommendationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIGenerateRecommendation(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIGenerateRecommendationRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.workloadOptimizationAPIGenerateRecommendation(requestParameters.clusterId, requestParameters.workloadId, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the adoption-weighted CPU billing metric for the given organization+cluster+window.
         * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetAdoptionWeightedCPURequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIGetAdoptionWeightedCPU(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetAdoptionWeightedCPURequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkloadoptimizationV1GetAdoptionWeightedCPUResponse> {
            return localVarFp.workloadOptimizationAPIGetAdoptionWeightedCPU(requestParameters.clusterId, requestParameters.organizationId, requestParameters.from, requestParameters.to, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns status of workload-autoscaler agent.
         * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetAgentStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIGetAgentStatus(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetAgentStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkloadoptimizationV1GetAgentStatusResponse> {
            return localVarFp.workloadOptimizationAPIGetAgentStatus(requestParameters.clusterId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary GetAggregatedWorkloadCustomMetrics returns aggregated custom metrics time-series data. Pods are aggregated across the workload, grouped by metric name and container.
         * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetAggregatedWorkloadCustomMetricsV1BetaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIGetAggregatedWorkloadCustomMetricsV1Beta(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetAggregatedWorkloadCustomMetricsV1BetaRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkloadoptimizationV1GetAggregatedWorkloadCustomMetricsV1BetaResponse> {
            return localVarFp.workloadOptimizationAPIGetAggregatedWorkloadCustomMetricsV1Beta(requestParameters.clusterId, requestParameters.workloadId, requestParameters.containerName, requestParameters.fromTime, requestParameters.toTime, requestParameters.aggregationSlidingWindow, requestParameters.aggregationType, requestParameters.step, requestParameters.aggregationPercentile, requestParameters.backfillDataPoints, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns HPA v2 migration eligibility for a cluster
         * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetHPAV2MigrationEligibilityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIGetHPAV2MigrationEligibility(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetHPAV2MigrationEligibilityRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkloadoptimizationV1GetHPAV2MigrationEligibilityResponse> {
            return localVarFp.workloadOptimizationAPIGetHPAV2MigrationEligibility(requestParameters.clusterId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns status of workload-autoscaler agents for all clusters in an organization.
         * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetOrganizationAgentStatusesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIGetOrganizationAgentStatuses(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetOrganizationAgentStatusesRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkloadoptimizationV1GetOrganizationAgentStatusesResponse> {
            return localVarFp.workloadOptimizationAPIGetOrganizationAgentStatuses(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a workload by a given id.
         * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIGetWorkload(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkloadoptimizationV1GetWorkloadResponse> {
            return localVarFp.workloadOptimizationAPIGetWorkload(requestParameters.clusterId, requestParameters.workloadId, requestParameters.includeMetrics, requestParameters.includeCosts, requestParameters.fromTime, requestParameters.toTime, requestParameters.scopeValue, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns raw custom metrics time-series data for a workload.
         * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadCustomMetricsV1BetaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIGetWorkloadCustomMetricsV1Beta(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadCustomMetricsV1BetaRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkloadoptimizationV1GetWorkloadCustomMetricsV1BetaResponse> {
            return localVarFp.workloadOptimizationAPIGetWorkloadCustomMetricsV1Beta(requestParameters.clusterId, requestParameters.workloadId, requestParameters.containerName, requestParameters.fromTime, requestParameters.toTime, requestParameters.step, requestParameters.backfillDataPoints, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a specific workload event by the given id.
         * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadEventRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIGetWorkloadEvent(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadEventRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkloadoptimizationV1GetWorkloadEventResponse> {
            return localVarFp.workloadOptimizationAPIGetWorkloadEvent(requestParameters.clusterId, requestParameters.eventId, requestParameters.createdAt, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a workload events summary for given cluster.
         * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadEventsSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIGetWorkloadEventsSummary(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadEventsSummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkloadoptimizationV1GetWorkloadEventsSummaryResponse> {
            return localVarFp.workloadOptimizationAPIGetWorkloadEventsSummary(requestParameters.clusterId, requestParameters.fromDate, requestParameters.toDate, requestParameters.workloadId, requestParameters.workloadName, requestParameters.workloadNamespace, requestParameters.workloadKind, requestParameters.type, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns workload filter values.
         * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIGetWorkloadFilters(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadFiltersRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkloadoptimizationV1GetWorkloadFiltersResponse> {
            return localVarFp.workloadOptimizationAPIGetWorkloadFilters(requestParameters.clusterId, requestParameters.managementOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns step-bucketed GPU utilization time-series and recommendations for a workload.
         * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadGPUMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIGetWorkloadGPUMetrics(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadGPUMetricsRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkloadoptimizationV1GetWorkloadGPUMetricsResponse> {
            return localVarFp.workloadOptimizationAPIGetWorkloadGPUMetrics(requestParameters.clusterId, requestParameters.workloadId, requestParameters.from, requestParameters.to, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns native VPA spec of the workload by a given id.
         * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadNativeVpaSpecRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIGetWorkloadNativeVpaSpec(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadNativeVpaSpecRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkloadoptimizationV1GetWorkloadNativeVpaSpecResponse> {
            return localVarFp.workloadOptimizationAPIGetWorkloadNativeVpaSpec(requestParameters.clusterId, requestParameters.workloadId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the deployed Recommendation CR manifest for the workload, sourced from the latest cluster snapshot.
         * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadRecommendationManifestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIGetWorkloadRecommendationManifest(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadRecommendationManifestRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkloadoptimizationV1GetWorkloadRecommendationManifestResponse> {
            return localVarFp.workloadOptimizationAPIGetWorkloadRecommendationManifest(requestParameters.clusterId, requestParameters.workloadId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns scaling policy.
         * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadScalingPolicyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIGetWorkloadScalingPolicy(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadScalingPolicyRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkloadoptimizationV1WorkloadScalingPolicy> {
            return localVarFp.workloadOptimizationAPIGetWorkloadScalingPolicy(requestParameters.clusterId, requestParameters.policyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a spec of the workload by a given id.
         * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadSpecRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIGetWorkloadSpec(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadSpecRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkloadoptimizationV1GetWorkloadSpecResponse> {
            return localVarFp.workloadOptimizationAPIGetWorkloadSpec(requestParameters.clusterId, requestParameters.workloadId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a workloads access context for a given cluster.
         * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadsAccessContextRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIGetWorkloadsAccessContext(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadsAccessContextRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkloadoptimizationV1GetWorkloadsAccessContextResponse> {
            return localVarFp.workloadOptimizationAPIGetWorkloadsAccessContext(requestParameters.clusterId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns workloads optimization summary.
         * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadsSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIGetWorkloadsSummary(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadsSummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkloadoptimizationV1GetWorkloadsSummaryResponse> {
            return localVarFp.workloadOptimizationAPIGetWorkloadsSummary(requestParameters.clusterId, requestParameters.includeCosts, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns workloads summary time series.
         * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadsSummaryMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIGetWorkloadsSummaryMetrics(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadsSummaryMetricsRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkloadoptimizationV1GetWorkloadsSummaryMetricsResponse> {
            return localVarFp.workloadOptimizationAPIGetWorkloadsSummaryMetrics(requestParameters.clusterId, requestParameters.fromTime, requestParameters.toTime, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all HPAs configured on workloads in the given cluster, including workload context (requests, P75 usage, recommendation, current pod count) and an optional converted HPA spec produced by a named converter. The UI is expected to perform aggregation, filtering and pagination client-side.
         * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIListClusterHPAsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIListClusterHPAs(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIListClusterHPAsRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkloadoptimizationV1ListClusterHPAsResponse> {
            return localVarFp.workloadOptimizationAPIListClusterHPAs(requestParameters.clusterId, requestParameters.workloadNames, requestParameters.namespaces, requestParameters.scalingPolicyNames, requestParameters.kinds, requestParameters.managementOptions, requestParameters.includeConversion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a list of custom metrics data sources for given cluster.
         * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIListCustomMetricsDataSourcesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIListCustomMetricsDataSources(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIListCustomMetricsDataSourcesRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkloadoptimizationV1ListCustomMetricsDataSourcesResponse> {
            return localVarFp.workloadOptimizationAPIListCustomMetricsDataSources(requestParameters.clusterId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a list of limit ranges for given cluster.
         * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIListLimitRangesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIListLimitRanges(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIListLimitRangesRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkloadoptimizationV1ListLimitRangesResponse> {
            return localVarFp.workloadOptimizationAPIListLimitRanges(requestParameters.clusterId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a list of resource quotas for given cluster.
         * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIListResourceQuotasRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIListResourceQuotas(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIListResourceQuotasRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkloadoptimizationV1ListResourceQuotasResponse> {
            return localVarFp.workloadOptimizationAPIListResourceQuotas(requestParameters.clusterId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a list of workload events for given cluster.
         * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIListWorkloadEventsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIListWorkloadEvents(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIListWorkloadEventsRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkloadoptimizationV1ListWorkloadEventsResponse> {
            return localVarFp.workloadOptimizationAPIListWorkloadEvents(requestParameters.clusterId, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.fromDate, requestParameters.toDate, requestParameters.workloadId, requestParameters.workloadName, requestParameters.workloadNamespace, requestParameters.workloadKind, requestParameters.type, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a list of workload scaling policies for given cluster.
         * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIListWorkloadScalingPoliciesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIListWorkloadScalingPolicies(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIListWorkloadScalingPoliciesRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkloadoptimizationV1ListWorkloadScalingPoliciesResponse> {
            return localVarFp.workloadOptimizationAPIListWorkloadScalingPolicies(requestParameters.clusterId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a list of workloads for the given cluster.
         * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIListWorkloadsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIListWorkloads(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIListWorkloadsRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkloadoptimizationV1ListWorkloadsResponse> {
            return localVarFp.workloadOptimizationAPIListWorkloads(requestParameters.clusterId, requestParameters.workloadIds, requestParameters.workloadNames, requestParameters.namespaces, requestParameters.scalingPolicyNames, requestParameters.kinds, requestParameters.managementOptions, requestParameters.configuredBy, requestParameters.searchQuery, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.sortField, requestParameters.sortOrder, requestParameters.recommendationStatusType, requestParameters.recommendationIsLowConfidence, requestParameters.workloadHasError, requestParameters.workloadHasCustomMetrics, requestParameters.anyContainerWithRuntime, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Migrates all eligible cluster workloads to HPA v2
         * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIMigrateClusterToHPAV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIMigrateClusterToHPAV2(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIMigrateClusterToHPAV2Request, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.workloadOptimizationAPIMigrateClusterToHPAV2(requestParameters.clusterId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Partially updates a scaling policy. Only fields covered by the update mask are modified; all other fields keep their current values.
         * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIPatchWorkloadScalingPolicyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIPatchWorkloadScalingPolicy(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIPatchWorkloadScalingPolicyRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkloadoptimizationV1WorkloadScalingPolicy> {
            return localVarFp.workloadOptimizationAPIPatchWorkloadScalingPolicy(requestParameters.clusterId, requestParameters.policyId, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates a CAST AI managed workload V2 partially using field mask.
         * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIPatchWorkloadV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIPatchWorkloadV2(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIPatchWorkloadV2Request, options?: RawAxiosRequestConfig): AxiosPromise<WorkloadoptimizationV1UpdateWorkloadResponseV2> {
            return localVarFp.workloadOptimizationAPIPatchWorkloadV2(requestParameters.clusterId, requestParameters.workloadId, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Query workload metrics time series.
         * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIQueryWorkloadMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIQueryWorkloadMetrics(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIQueryWorkloadMetricsRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkloadoptimizationV1QueryWorkloadMetricsResponse> {
            return localVarFp.workloadOptimizationAPIQueryWorkloadMetrics(requestParameters.clusterId, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resets the system overrides for a workload.
         * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIResetSystemOverridesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIResetSystemOverrides(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIResetSystemOverridesRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkloadoptimizationV1ResetSystemOverridesResponse> {
            return localVarFp.workloadOptimizationAPIResetSystemOverrides(requestParameters.clusterId, requestParameters.workloadId, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * Determines the order in which policies are applied to workloads based on assignment rules. By default, policies are sorted by their creation timestamp (CreatedAt).  You MUST provide the complete list of policy IDs in the exact order they should be applied.
         * @summary Updates the order of scaling policies for a given cluster.
         * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPISetScalingPoliciesOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPISetScalingPoliciesOrder(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPISetScalingPoliciesOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.workloadOptimizationAPISetScalingPoliciesOrder(requestParameters.clusterId, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary SyncSystemPolicyAssignmentRules syncs assignment rules from system scaling policies to target clusters. This is an internal-only endpoint used by the admin service.
         * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPISyncSystemPolicyAssignmentRulesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPISyncSystemPolicyAssignmentRules(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPISyncSystemPolicyAssignmentRulesRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkloadoptimizationV1SyncSystemPolicyAssignmentRulesResponse> {
            return localVarFp.workloadOptimizationAPISyncSystemPolicyAssignmentRules(requestParameters.organizationId, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates a custom metrics data source.
         * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIUpdateCustomMetricsDataSourceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIUpdateCustomMetricsDataSource(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIUpdateCustomMetricsDataSourceRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkloadoptimizationV1CustomMetricsDataSource> {
            return localVarFp.workloadOptimizationAPIUpdateCustomMetricsDataSource(requestParameters.clusterId, requestParameters.id, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates a scaling policy.
         * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIUpdateWorkloadScalingPolicyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIUpdateWorkloadScalingPolicy(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIUpdateWorkloadScalingPolicyRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkloadoptimizationV1WorkloadScalingPolicy> {
            return localVarFp.workloadOptimizationAPIUpdateWorkloadScalingPolicy(requestParameters.clusterId, requestParameters.policyId, requestParameters.policy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates a CAST AI managed workload V2.
         * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIUpdateWorkloadV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workloadOptimizationAPIUpdateWorkloadV2(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIUpdateWorkloadV2Request, options?: RawAxiosRequestConfig): AxiosPromise<WorkloadoptimizationV1UpdateWorkloadResponseV2> {
            return localVarFp.workloadOptimizationAPIUpdateWorkloadV2(requestParameters.clusterId, requestParameters.workloadId, requestParameters.workload, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for workloadOptimizationAPIAssignScalingPolicyWorkloads operation in WorkloadOptimizationAPIApi.
 * @export
 * @interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIAssignScalingPolicyWorkloadsRequest
 */
export interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIAssignScalingPolicyWorkloadsRequest {
    /**
     * Cluster ID associated with the scaling policy.
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIAssignScalingPolicyWorkloads
     */
    readonly clusterId: string

    /**
     * Policy ID associated with the scaling policy.
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIAssignScalingPolicyWorkloads
     */
    readonly policyId: string

    /**
     * 
     * @type {WorkloadOptimizationAPIAssignScalingPolicyWorkloadsRequest}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIAssignScalingPolicyWorkloads
     */
    readonly body: WorkloadOptimizationAPIAssignScalingPolicyWorkloadsRequest
}

/**
 * Request parameters for workloadOptimizationAPICreateCustomMetricsDataSource operation in WorkloadOptimizationAPIApi.
 * @export
 * @interface WorkloadOptimizationAPIApiWorkloadOptimizationAPICreateCustomMetricsDataSourceRequest
 */
export interface WorkloadOptimizationAPIApiWorkloadOptimizationAPICreateCustomMetricsDataSourceRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPICreateCustomMetricsDataSource
     */
    readonly clusterId: string

    /**
     * 
     * @type {WorkloadoptimizationV1NewCustomMetricsDataSource}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPICreateCustomMetricsDataSource
     */
    readonly dataSource: WorkloadoptimizationV1NewCustomMetricsDataSource
}

/**
 * Request parameters for workloadOptimizationAPICreateWorkloadScalingPolicy operation in WorkloadOptimizationAPIApi.
 * @export
 * @interface WorkloadOptimizationAPIApiWorkloadOptimizationAPICreateWorkloadScalingPolicyRequest
 */
export interface WorkloadOptimizationAPIApiWorkloadOptimizationAPICreateWorkloadScalingPolicyRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPICreateWorkloadScalingPolicy
     */
    readonly clusterId: string

    /**
     * 
     * @type {WorkloadoptimizationV1NewWorkloadScalingPolicy}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPICreateWorkloadScalingPolicy
     */
    readonly policy: WorkloadoptimizationV1NewWorkloadScalingPolicy
}

/**
 * Request parameters for workloadOptimizationAPIDeleteCustomMetricsDataSource operation in WorkloadOptimizationAPIApi.
 * @export
 * @interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIDeleteCustomMetricsDataSourceRequest
 */
export interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIDeleteCustomMetricsDataSourceRequest {
    /**
     * The cluster ID that owns this custom metrics data source.
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIDeleteCustomMetricsDataSource
     */
    readonly clusterId: string

    /**
     * The ID of the custom metrics data source to delete.
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIDeleteCustomMetricsDataSource
     */
    readonly id: string
}

/**
 * Request parameters for workloadOptimizationAPIDeleteWorkloadScalingPolicy operation in WorkloadOptimizationAPIApi.
 * @export
 * @interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIDeleteWorkloadScalingPolicyRequest
 */
export interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIDeleteWorkloadScalingPolicyRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIDeleteWorkloadScalingPolicy
     */
    readonly clusterId: string

    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIDeleteWorkloadScalingPolicy
     */
    readonly policyId: string
}

/**
 * Request parameters for workloadOptimizationAPIDisableCluster operation in WorkloadOptimizationAPIApi.
 * @export
 * @interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIDisableClusterRequest
 */
export interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIDisableClusterRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIDisableCluster
     */
    readonly clusterId: string

    /**
     * 
     * @type {WorkloadOptimizationAPIDisableClusterRequest}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIDisableCluster
     */
    readonly body: WorkloadOptimizationAPIDisableClusterRequest
}

/**
 * Request parameters for workloadOptimizationAPIEnableCluster operation in WorkloadOptimizationAPIApi.
 * @export
 * @interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIEnableClusterRequest
 */
export interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIEnableClusterRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIEnableCluster
     */
    readonly clusterId: string

    /**
     * 
     * @type {WorkloadOptimizationAPIEnableClusterRequest}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIEnableCluster
     */
    readonly body: WorkloadOptimizationAPIEnableClusterRequest
}

/**
 * Request parameters for workloadOptimizationAPIGenerateRecommendation operation in WorkloadOptimizationAPIApi.
 * @export
 * @interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIGenerateRecommendationRequest
 */
export interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIGenerateRecommendationRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGenerateRecommendation
     */
    readonly clusterId: string

    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGenerateRecommendation
     */
    readonly workloadId: string

    /**
     * 
     * @type {object}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGenerateRecommendation
     */
    readonly body: object
}

/**
 * Request parameters for workloadOptimizationAPIGetAdoptionWeightedCPU operation in WorkloadOptimizationAPIApi.
 * @export
 * @interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetAdoptionWeightedCPURequest
 */
export interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetAdoptionWeightedCPURequest {
    /**
     * The cluster within the organization. Required, must be a valid UUID.
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetAdoptionWeightedCPU
     */
    readonly clusterId: string

    /**
     * The organization for which to compute the metric. Required, must be a valid UUID.
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetAdoptionWeightedCPU
     */
    readonly organizationId: string

    /**
     * Inclusive start of the billing window. Required. Must be in the past and within the last 60 days (matches the workloads_summary TTL). Handler also enforces from &lt; to and (to - from) &lt;&#x3D; 30 days.
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetAdoptionWeightedCPU
     */
    readonly from: string

    /**
     * Exclusive end of the billing window. Required. Must be in the past and within the last 60 days (matches the workloads_summary TTL). Handler also enforces from &lt; to and (to - from) &lt;&#x3D; 30 days.
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetAdoptionWeightedCPU
     */
    readonly to: string
}

/**
 * Request parameters for workloadOptimizationAPIGetAgentStatus operation in WorkloadOptimizationAPIApi.
 * @export
 * @interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetAgentStatusRequest
 */
export interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetAgentStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetAgentStatus
     */
    readonly clusterId: string
}

/**
 * Request parameters for workloadOptimizationAPIGetAggregatedWorkloadCustomMetricsV1Beta operation in WorkloadOptimizationAPIApi.
 * @export
 * @interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetAggregatedWorkloadCustomMetricsV1BetaRequest
 */
export interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetAggregatedWorkloadCustomMetricsV1BetaRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetAggregatedWorkloadCustomMetricsV1Beta
     */
    readonly clusterId: string

    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetAggregatedWorkloadCustomMetricsV1Beta
     */
    readonly workloadId: string

    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetAggregatedWorkloadCustomMetricsV1Beta
     */
    readonly containerName: string

    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetAggregatedWorkloadCustomMetricsV1Beta
     */
    readonly fromTime: string

    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetAggregatedWorkloadCustomMetricsV1Beta
     */
    readonly toTime: string

    /**
     * Sliding window duration for aggregation (e.g. 30 minutes).
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetAggregatedWorkloadCustomMetricsV1Beta
     */
    readonly aggregationSlidingWindow: string

    /**
     * 
     * @type {'CUSTOM_METRIC_AGGREGATION_TYPE_UNSPECIFIED' | 'AVERAGE' | 'MAX' | 'MIN' | 'PERCENTILE'}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetAggregatedWorkloadCustomMetricsV1Beta
     */
    readonly aggregationType: WorkloadOptimizationAPIGetAggregatedWorkloadCustomMetricsV1BetaAggregationTypeEnum

    /**
     * Sampling interval for metrics. The server may enforce a step even when one is not provided, or change it if it\&#39;s too short. The actual step used is returned in the response.
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetAggregatedWorkloadCustomMetricsV1Beta
     */
    readonly step?: string

    /**
     * Only used when type is PERCENTILE (e.g. 95 for p95).
     * @type {number}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetAggregatedWorkloadCustomMetricsV1Beta
     */
    readonly aggregationPercentile?: number

    /**
     * When true, missing data points in the time range are backfilled with null values at each step interval.
     * @type {boolean}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetAggregatedWorkloadCustomMetricsV1Beta
     */
    readonly backfillDataPoints?: boolean
}

/**
 * Request parameters for workloadOptimizationAPIGetHPAV2MigrationEligibility operation in WorkloadOptimizationAPIApi.
 * @export
 * @interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetHPAV2MigrationEligibilityRequest
 */
export interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetHPAV2MigrationEligibilityRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetHPAV2MigrationEligibility
     */
    readonly clusterId: string
}

/**
 * Request parameters for workloadOptimizationAPIGetOrganizationAgentStatuses operation in WorkloadOptimizationAPIApi.
 * @export
 * @interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetOrganizationAgentStatusesRequest
 */
export interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetOrganizationAgentStatusesRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetOrganizationAgentStatuses
     */
    readonly organizationId: string
}

/**
 * Request parameters for workloadOptimizationAPIGetWorkload operation in WorkloadOptimizationAPIApi.
 * @export
 * @interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadRequest
 */
export interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkload
     */
    readonly clusterId: string

    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkload
     */
    readonly workloadId: string

    /**
     * 
     * @type {boolean}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkload
     */
    readonly includeMetrics?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkload
     */
    readonly includeCosts?: boolean

    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkload
     */
    readonly fromTime?: string

    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkload
     */
    readonly toTime?: string

    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkload
     */
    readonly scopeValue?: string
}

/**
 * Request parameters for workloadOptimizationAPIGetWorkloadCustomMetricsV1Beta operation in WorkloadOptimizationAPIApi.
 * @export
 * @interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadCustomMetricsV1BetaRequest
 */
export interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadCustomMetricsV1BetaRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadCustomMetricsV1Beta
     */
    readonly clusterId: string

    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadCustomMetricsV1Beta
     */
    readonly workloadId: string

    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadCustomMetricsV1Beta
     */
    readonly containerName: string

    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadCustomMetricsV1Beta
     */
    readonly fromTime: string

    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadCustomMetricsV1Beta
     */
    readonly toTime: string

    /**
     * Sampling interval for metrics. For long time ranges, the server may enforce a step even if one is not provided. The actual step used is returned in the response.
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadCustomMetricsV1Beta
     */
    readonly step?: string

    /**
     * When true, missing data points in the time range are backfilled with null values at each step interval. Requires a step to be in effect (explicitly requested or server-calculated). Ignored when no step applies.
     * @type {boolean}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadCustomMetricsV1Beta
     */
    readonly backfillDataPoints?: boolean
}

/**
 * Request parameters for workloadOptimizationAPIGetWorkloadEvent operation in WorkloadOptimizationAPIApi.
 * @export
 * @interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadEventRequest
 */
export interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadEventRequest {
    /**
     * The Cluster ID in which the given event happened.
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadEvent
     */
    readonly clusterId: string

    /**
     * The ID of the event.
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadEvent
     */
    readonly eventId: string

    /**
     * The creation time of the event.
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadEvent
     */
    readonly createdAt: string
}

/**
 * Request parameters for workloadOptimizationAPIGetWorkloadEventsSummary operation in WorkloadOptimizationAPIApi.
 * @export
 * @interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadEventsSummaryRequest
 */
export interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadEventsSummaryRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadEventsSummary
     */
    readonly clusterId: string

    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadEventsSummary
     */
    readonly fromDate?: string

    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadEventsSummary
     */
    readonly toDate?: string

    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadEventsSummary
     */
    readonly workloadId?: string

    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadEventsSummary
     */
    readonly workloadName?: string

    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadEventsSummary
     */
    readonly workloadNamespace?: string

    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadEventsSummary
     */
    readonly workloadKind?: string

    /**
     * 
     * @type {Array<'EVENT_TYPE_INVALID' | 'EVENT_TYPE_SURGE' | 'EVENT_TYPE_OOM_KILL' | 'EVENT_TYPE_CONFIGURATION_CHANGEDV2' | 'EVENT_TYPE_RECOMMENDED_POD_COUNT_CHANGED' | 'EVENT_TYPE_RECOMMENDED_REQUESTS_CHANGED' | 'EVENT_TYPE_SCALING_POLICY_CREATED' | 'EVENT_TYPE_SCALING_POLICY_DELETED' | 'EVENT_TYPE_SCALING_POLICY_UPDATED' | 'EVENT_TYPE_SCALING_POLICY_ASSIGNED' | 'EVENT_TYPE_FAILED_HELM_TEST_HOOK' | 'EVENT_TYPE_SCALING_POLICY_ORDER_UPDATED' | 'EVENT_TYPE_MEMORY_PRESSURE_EVICTION' | 'EVENT_TYPE_SYSTEM_OVERRIDE_TRIGGERED' | 'EVENT_TYPE_SYSTEM_OVERRIDE_RESET' | 'EVENT_TYPE_STARTUP_FAILURE' | 'EVENT_TYPE_CPU_PRESSURE' | 'EVENT_TYPE_HPA_MAXED_OUT' | 'EVENT_TYPE_HPA_ALMOST_MAXED_OUT' | 'EVENT_TYPE_UNBOUND_MEMORY_GROWTH' | 'EVENT_TYPE_CPU_PRESSURE_RESOLVED' | 'EVENT_TYPE_NATIVE_VPA_STATE_CHANGED' | 'EVENT_TYPE_GPU_RECOMMENDED_REQUESTS_CHANGED' | 'EVENT_TYPE_WORKLOAD_AUTOSCALER_INSTALLED' | 'EVENT_TYPE_WORKLOAD_AUTOSCALER_UNINSTALLED' | 'EVENT_TYPE_UNSCHEDULABLE_RECOMMENDATION'>}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadEventsSummary
     */
    readonly type?: Array<WorkloadOptimizationAPIGetWorkloadEventsSummaryTypeEnum>
}

/**
 * Request parameters for workloadOptimizationAPIGetWorkloadFilters operation in WorkloadOptimizationAPIApi.
 * @export
 * @interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadFiltersRequest
 */
export interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadFiltersRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadFilters
     */
    readonly clusterId: string

    /**
     * 
     * @type {Array<'UNDEFINED' | 'READ_ONLY' | 'MANAGED'>}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadFilters
     */
    readonly managementOptions?: Array<WorkloadOptimizationAPIGetWorkloadFiltersManagementOptionsEnum>
}

/**
 * Request parameters for workloadOptimizationAPIGetWorkloadGPUMetrics operation in WorkloadOptimizationAPIApi.
 * @export
 * @interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadGPUMetricsRequest
 */
export interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadGPUMetricsRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadGPUMetrics
     */
    readonly clusterId: string

    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadGPUMetrics
     */
    readonly workloadId: string

    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadGPUMetrics
     */
    readonly from?: string

    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadGPUMetrics
     */
    readonly to?: string
}

/**
 * Request parameters for workloadOptimizationAPIGetWorkloadNativeVpaSpec operation in WorkloadOptimizationAPIApi.
 * @export
 * @interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadNativeVpaSpecRequest
 */
export interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadNativeVpaSpecRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadNativeVpaSpec
     */
    readonly clusterId: string

    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadNativeVpaSpec
     */
    readonly workloadId: string
}

/**
 * Request parameters for workloadOptimizationAPIGetWorkloadRecommendationManifest operation in WorkloadOptimizationAPIApi.
 * @export
 * @interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadRecommendationManifestRequest
 */
export interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadRecommendationManifestRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadRecommendationManifest
     */
    readonly clusterId: string

    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadRecommendationManifest
     */
    readonly workloadId: string
}

/**
 * Request parameters for workloadOptimizationAPIGetWorkloadScalingPolicy operation in WorkloadOptimizationAPIApi.
 * @export
 * @interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadScalingPolicyRequest
 */
export interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadScalingPolicyRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadScalingPolicy
     */
    readonly clusterId: string

    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadScalingPolicy
     */
    readonly policyId: string
}

/**
 * Request parameters for workloadOptimizationAPIGetWorkloadSpec operation in WorkloadOptimizationAPIApi.
 * @export
 * @interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadSpecRequest
 */
export interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadSpecRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadSpec
     */
    readonly clusterId: string

    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadSpec
     */
    readonly workloadId: string
}

/**
 * Request parameters for workloadOptimizationAPIGetWorkloadsAccessContext operation in WorkloadOptimizationAPIApi.
 * @export
 * @interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadsAccessContextRequest
 */
export interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadsAccessContextRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadsAccessContext
     */
    readonly clusterId: string
}

/**
 * Request parameters for workloadOptimizationAPIGetWorkloadsSummary operation in WorkloadOptimizationAPIApi.
 * @export
 * @interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadsSummaryRequest
 */
export interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadsSummaryRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadsSummary
     */
    readonly clusterId: string

    /**
     * 
     * @type {boolean}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadsSummary
     */
    readonly includeCosts?: boolean
}

/**
 * Request parameters for workloadOptimizationAPIGetWorkloadsSummaryMetrics operation in WorkloadOptimizationAPIApi.
 * @export
 * @interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadsSummaryMetricsRequest
 */
export interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadsSummaryMetricsRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadsSummaryMetrics
     */
    readonly clusterId: string

    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadsSummaryMetrics
     */
    readonly fromTime?: string

    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadsSummaryMetrics
     */
    readonly toTime?: string
}

/**
 * Request parameters for workloadOptimizationAPIListClusterHPAs operation in WorkloadOptimizationAPIApi.
 * @export
 * @interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIListClusterHPAsRequest
 */
export interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIListClusterHPAsRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIListClusterHPAs
     */
    readonly clusterId: string

    /**
     * 
     * @type {Array<string>}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIListClusterHPAs
     */
    readonly workloadNames?: Array<string>

    /**
     * 
     * @type {Array<string>}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIListClusterHPAs
     */
    readonly namespaces?: Array<string>

    /**
     * 
     * @type {Array<string>}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIListClusterHPAs
     */
    readonly scalingPolicyNames?: Array<string>

    /**
     * 
     * @type {Array<string>}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIListClusterHPAs
     */
    readonly kinds?: Array<string>

    /**
     * 
     * @type {Array<'UNDEFINED' | 'READ_ONLY' | 'MANAGED'>}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIListClusterHPAs
     */
    readonly managementOptions?: Array<WorkloadOptimizationAPIListClusterHPAsManagementOptionsEnum>

    /**
     * Identifier of the HPA converter to apply to each returned HPA. When empty, no conversion is executed and the &#x60;conversion&#x60; field on each item is unset.   - AVERAGE_VALUE_FROM_ORIGINAL_REQUESTS: Converts HPA utilization (%) targets to AverageValue using workload container requests.
     * @type {'HPA_CONVERTER_TYPE_UNSPECIFIED' | 'AVERAGE_VALUE_FROM_ORIGINAL_REQUESTS'}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIListClusterHPAs
     */
    readonly includeConversion?: WorkloadOptimizationAPIListClusterHPAsIncludeConversionEnum
}

/**
 * Request parameters for workloadOptimizationAPIListCustomMetricsDataSources operation in WorkloadOptimizationAPIApi.
 * @export
 * @interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIListCustomMetricsDataSourcesRequest
 */
export interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIListCustomMetricsDataSourcesRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIListCustomMetricsDataSources
     */
    readonly clusterId: string
}

/**
 * Request parameters for workloadOptimizationAPIListLimitRanges operation in WorkloadOptimizationAPIApi.
 * @export
 * @interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIListLimitRangesRequest
 */
export interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIListLimitRangesRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIListLimitRanges
     */
    readonly clusterId: string
}

/**
 * Request parameters for workloadOptimizationAPIListResourceQuotas operation in WorkloadOptimizationAPIApi.
 * @export
 * @interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIListResourceQuotasRequest
 */
export interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIListResourceQuotasRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIListResourceQuotas
     */
    readonly clusterId: string
}

/**
 * Request parameters for workloadOptimizationAPIListWorkloadEvents operation in WorkloadOptimizationAPIApi.
 * @export
 * @interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIListWorkloadEventsRequest
 */
export interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIListWorkloadEventsRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIListWorkloadEvents
     */
    readonly clusterId: string

    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIListWorkloadEvents
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page. Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIListWorkloadEvents
     */
    readonly pageCursor?: string

    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIListWorkloadEvents
     */
    readonly fromDate?: string

    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIListWorkloadEvents
     */
    readonly toDate?: string

    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIListWorkloadEvents
     */
    readonly workloadId?: string

    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIListWorkloadEvents
     */
    readonly workloadName?: string

    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIListWorkloadEvents
     */
    readonly workloadNamespace?: string

    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIListWorkloadEvents
     */
    readonly workloadKind?: string

    /**
     * 
     * @type {Array<'EVENT_TYPE_INVALID' | 'EVENT_TYPE_SURGE' | 'EVENT_TYPE_OOM_KILL' | 'EVENT_TYPE_CONFIGURATION_CHANGEDV2' | 'EVENT_TYPE_RECOMMENDED_POD_COUNT_CHANGED' | 'EVENT_TYPE_RECOMMENDED_REQUESTS_CHANGED' | 'EVENT_TYPE_SCALING_POLICY_CREATED' | 'EVENT_TYPE_SCALING_POLICY_DELETED' | 'EVENT_TYPE_SCALING_POLICY_UPDATED' | 'EVENT_TYPE_SCALING_POLICY_ASSIGNED' | 'EVENT_TYPE_FAILED_HELM_TEST_HOOK' | 'EVENT_TYPE_SCALING_POLICY_ORDER_UPDATED' | 'EVENT_TYPE_MEMORY_PRESSURE_EVICTION' | 'EVENT_TYPE_SYSTEM_OVERRIDE_TRIGGERED' | 'EVENT_TYPE_SYSTEM_OVERRIDE_RESET' | 'EVENT_TYPE_STARTUP_FAILURE' | 'EVENT_TYPE_CPU_PRESSURE' | 'EVENT_TYPE_HPA_MAXED_OUT' | 'EVENT_TYPE_HPA_ALMOST_MAXED_OUT' | 'EVENT_TYPE_UNBOUND_MEMORY_GROWTH' | 'EVENT_TYPE_CPU_PRESSURE_RESOLVED' | 'EVENT_TYPE_NATIVE_VPA_STATE_CHANGED' | 'EVENT_TYPE_GPU_RECOMMENDED_REQUESTS_CHANGED' | 'EVENT_TYPE_WORKLOAD_AUTOSCALER_INSTALLED' | 'EVENT_TYPE_WORKLOAD_AUTOSCALER_UNINSTALLED' | 'EVENT_TYPE_UNSCHEDULABLE_RECOMMENDATION'>}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIListWorkloadEvents
     */
    readonly type?: Array<WorkloadOptimizationAPIListWorkloadEventsTypeEnum>
}

/**
 * Request parameters for workloadOptimizationAPIListWorkloadScalingPolicies operation in WorkloadOptimizationAPIApi.
 * @export
 * @interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIListWorkloadScalingPoliciesRequest
 */
export interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIListWorkloadScalingPoliciesRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIListWorkloadScalingPolicies
     */
    readonly clusterId: string
}

/**
 * Request parameters for workloadOptimizationAPIListWorkloads operation in WorkloadOptimizationAPIApi.
 * @export
 * @interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIListWorkloadsRequest
 */
export interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIListWorkloadsRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIListWorkloads
     */
    readonly clusterId: string

    /**
     * 
     * @type {Array<string>}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIListWorkloads
     */
    readonly workloadIds?: Array<string>

    /**
     * 
     * @type {Array<string>}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIListWorkloads
     */
    readonly workloadNames?: Array<string>

    /**
     * 
     * @type {Array<string>}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIListWorkloads
     */
    readonly namespaces?: Array<string>

    /**
     * 
     * @type {Array<string>}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIListWorkloads
     */
    readonly scalingPolicyNames?: Array<string>

    /**
     * 
     * @type {Array<string>}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIListWorkloads
     */
    readonly kinds?: Array<string>

    /**
     * 
     * @type {Array<'UNDEFINED' | 'READ_ONLY' | 'MANAGED'>}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIListWorkloads
     */
    readonly managementOptions?: Array<WorkloadOptimizationAPIListWorkloadsManagementOptionsEnum>

    /**
     * 
     * @type {Array<string>}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIListWorkloads
     */
    readonly configuredBy?: Array<string>

    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIListWorkloads
     */
    readonly searchQuery?: string

    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIListWorkloads
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page. Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIListWorkloads
     */
    readonly pageCursor?: string

    /**
     * Name of the field you want to sort
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIListWorkloads
     */
    readonly sortField?: string

    /**
     * The sort order, possible values ASC or DESC, if not provided asc is the default   - ASC: ASC  - asc: desc  - DESC: ASC  - desc: desc
     * @type {'ASC' | 'asc' | 'DESC' | 'desc'}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIListWorkloads
     */
    readonly sortOrder?: WorkloadOptimizationAPIListWorkloadsSortOrderEnum

    /**
     * 
     * @type {'STATUS_UNKNOWN' | 'STATUS_WAITING' | 'STATUS_APPLIED' | 'STATUS_STOPPED'}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIListWorkloads
     */
    readonly recommendationStatusType?: WorkloadOptimizationAPIListWorkloadsRecommendationStatusTypeEnum

    /**
     * 
     * @type {boolean}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIListWorkloads
     */
    readonly recommendationIsLowConfidence?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIListWorkloads
     */
    readonly workloadHasError?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIListWorkloads
     */
    readonly workloadHasCustomMetrics?: boolean

    /**
     * 
     * @type {'RUNTIME_UNSPECIFIED' | 'JVM' | 'GPU'}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIListWorkloads
     */
    readonly anyContainerWithRuntime?: WorkloadOptimizationAPIListWorkloadsAnyContainerWithRuntimeEnum
}

/**
 * Request parameters for workloadOptimizationAPIMigrateClusterToHPAV2 operation in WorkloadOptimizationAPIApi.
 * @export
 * @interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIMigrateClusterToHPAV2Request
 */
export interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIMigrateClusterToHPAV2Request {
    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIMigrateClusterToHPAV2
     */
    readonly clusterId: string
}

/**
 * Request parameters for workloadOptimizationAPIPatchWorkloadScalingPolicy operation in WorkloadOptimizationAPIApi.
 * @export
 * @interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIPatchWorkloadScalingPolicyRequest
 */
export interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIPatchWorkloadScalingPolicyRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIPatchWorkloadScalingPolicy
     */
    readonly clusterId: string

    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIPatchWorkloadScalingPolicy
     */
    readonly policyId: string

    /**
     * 
     * @type {WorkloadOptimizationAPIPatchWorkloadScalingPolicyRequest}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIPatchWorkloadScalingPolicy
     */
    readonly body: WorkloadOptimizationAPIPatchWorkloadScalingPolicyRequest
}

/**
 * Request parameters for workloadOptimizationAPIPatchWorkloadV2 operation in WorkloadOptimizationAPIApi.
 * @export
 * @interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIPatchWorkloadV2Request
 */
export interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIPatchWorkloadV2Request {
    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIPatchWorkloadV2
     */
    readonly clusterId: string

    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIPatchWorkloadV2
     */
    readonly workloadId: string

    /**
     * 
     * @type {WorkloadOptimizationAPIPatchWorkloadV2Request}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIPatchWorkloadV2
     */
    readonly body: WorkloadOptimizationAPIPatchWorkloadV2Request
}

/**
 * Request parameters for workloadOptimizationAPIQueryWorkloadMetrics operation in WorkloadOptimizationAPIApi.
 * @export
 * @interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIQueryWorkloadMetricsRequest
 */
export interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIQueryWorkloadMetricsRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIQueryWorkloadMetrics
     */
    readonly clusterId: string

    /**
     * 
     * @type {WorkloadOptimizationAPIQueryWorkloadMetricsRequest}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIQueryWorkloadMetrics
     */
    readonly body: WorkloadOptimizationAPIQueryWorkloadMetricsRequest
}

/**
 * Request parameters for workloadOptimizationAPIResetSystemOverrides operation in WorkloadOptimizationAPIApi.
 * @export
 * @interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIResetSystemOverridesRequest
 */
export interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIResetSystemOverridesRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIResetSystemOverrides
     */
    readonly clusterId: string

    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIResetSystemOverrides
     */
    readonly workloadId: string

    /**
     * 
     * @type {WorkloadOptimizationAPIResetSystemOverridesRequest}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIResetSystemOverrides
     */
    readonly body: WorkloadOptimizationAPIResetSystemOverridesRequest
}

/**
 * Request parameters for workloadOptimizationAPISetScalingPoliciesOrder operation in WorkloadOptimizationAPIApi.
 * @export
 * @interface WorkloadOptimizationAPIApiWorkloadOptimizationAPISetScalingPoliciesOrderRequest
 */
export interface WorkloadOptimizationAPIApiWorkloadOptimizationAPISetScalingPoliciesOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPISetScalingPoliciesOrder
     */
    readonly clusterId: string

    /**
     * 
     * @type {WorkloadOptimizationAPISetScalingPoliciesOrderRequest}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPISetScalingPoliciesOrder
     */
    readonly body: WorkloadOptimizationAPISetScalingPoliciesOrderRequest
}

/**
 * Request parameters for workloadOptimizationAPISyncSystemPolicyAssignmentRules operation in WorkloadOptimizationAPIApi.
 * @export
 * @interface WorkloadOptimizationAPIApiWorkloadOptimizationAPISyncSystemPolicyAssignmentRulesRequest
 */
export interface WorkloadOptimizationAPIApiWorkloadOptimizationAPISyncSystemPolicyAssignmentRulesRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPISyncSystemPolicyAssignmentRules
     */
    readonly organizationId: string

    /**
     * 
     * @type {WorkloadOptimizationAPISyncSystemPolicyAssignmentRulesRequest}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPISyncSystemPolicyAssignmentRules
     */
    readonly body: WorkloadOptimizationAPISyncSystemPolicyAssignmentRulesRequest
}

/**
 * Request parameters for workloadOptimizationAPIUpdateCustomMetricsDataSource operation in WorkloadOptimizationAPIApi.
 * @export
 * @interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIUpdateCustomMetricsDataSourceRequest
 */
export interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIUpdateCustomMetricsDataSourceRequest {
    /**
     * The cluster ID that owns this custom metrics data source.
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIUpdateCustomMetricsDataSource
     */
    readonly clusterId: string

    /**
     * The ID of the custom metrics data source to update.
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIUpdateCustomMetricsDataSource
     */
    readonly id: string

    /**
     * 
     * @type {WorkloadOptimizationAPIUpdateCustomMetricsDataSourceRequest}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIUpdateCustomMetricsDataSource
     */
    readonly body: WorkloadOptimizationAPIUpdateCustomMetricsDataSourceRequest
}

/**
 * Request parameters for workloadOptimizationAPIUpdateWorkloadScalingPolicy operation in WorkloadOptimizationAPIApi.
 * @export
 * @interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIUpdateWorkloadScalingPolicyRequest
 */
export interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIUpdateWorkloadScalingPolicyRequest {
    /**
     * Cluster ID associated with the scaling policy.
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIUpdateWorkloadScalingPolicy
     */
    readonly clusterId: string

    /**
     * Policy ID associated with the scaling policy.
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIUpdateWorkloadScalingPolicy
     */
    readonly policyId: string

    /**
     * The values to configure for the policy.
     * @type {WorkloadoptimizationV1UpdateWorkloadScalingPolicy}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIUpdateWorkloadScalingPolicy
     */
    readonly policy: WorkloadoptimizationV1UpdateWorkloadScalingPolicy
}

/**
 * Request parameters for workloadOptimizationAPIUpdateWorkloadV2 operation in WorkloadOptimizationAPIApi.
 * @export
 * @interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIUpdateWorkloadV2Request
 */
export interface WorkloadOptimizationAPIApiWorkloadOptimizationAPIUpdateWorkloadV2Request {
    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIUpdateWorkloadV2
     */
    readonly clusterId: string

    /**
     * 
     * @type {string}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIUpdateWorkloadV2
     */
    readonly workloadId: string

    /**
     * 
     * @type {WorkloadoptimizationV1UpdateWorkloadV2}
     * @memberof WorkloadOptimizationAPIApiWorkloadOptimizationAPIUpdateWorkloadV2
     */
    readonly workload: WorkloadoptimizationV1UpdateWorkloadV2
}

/**
 * WorkloadOptimizationAPIApi - object-oriented interface
 * @export
 * @class WorkloadOptimizationAPIApi
 * @extends {BaseAPI}
 */
export class WorkloadOptimizationAPIApi extends BaseAPI {
    /**
     * 
     * @summary Assigns the provided list of workload IDs to the specified policy.
     * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIAssignScalingPolicyWorkloadsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadOptimizationAPIApi
     */
    public workloadOptimizationAPIAssignScalingPolicyWorkloads(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIAssignScalingPolicyWorkloadsRequest, options?: RawAxiosRequestConfig) {
        return WorkloadOptimizationAPIApiFp(this.configuration).workloadOptimizationAPIAssignScalingPolicyWorkloads(requestParameters.clusterId, requestParameters.policyId, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates a custom metrics data source for given cluster.
     * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPICreateCustomMetricsDataSourceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadOptimizationAPIApi
     */
    public workloadOptimizationAPICreateCustomMetricsDataSource(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPICreateCustomMetricsDataSourceRequest, options?: RawAxiosRequestConfig) {
        return WorkloadOptimizationAPIApiFp(this.configuration).workloadOptimizationAPICreateCustomMetricsDataSource(requestParameters.clusterId, requestParameters.dataSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates a scaling policy that can be assigned to workloads at a later time.
     * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPICreateWorkloadScalingPolicyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadOptimizationAPIApi
     */
    public workloadOptimizationAPICreateWorkloadScalingPolicy(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPICreateWorkloadScalingPolicyRequest, options?: RawAxiosRequestConfig) {
        return WorkloadOptimizationAPIApiFp(this.configuration).workloadOptimizationAPICreateWorkloadScalingPolicy(requestParameters.clusterId, requestParameters.policy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes a custom metrics data source.
     * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIDeleteCustomMetricsDataSourceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadOptimizationAPIApi
     */
    public workloadOptimizationAPIDeleteCustomMetricsDataSource(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIDeleteCustomMetricsDataSourceRequest, options?: RawAxiosRequestConfig) {
        return WorkloadOptimizationAPIApiFp(this.configuration).workloadOptimizationAPIDeleteCustomMetricsDataSource(requestParameters.clusterId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes a scaling policy.
     * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIDeleteWorkloadScalingPolicyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadOptimizationAPIApi
     */
    public workloadOptimizationAPIDeleteWorkloadScalingPolicy(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIDeleteWorkloadScalingPolicyRequest, options?: RawAxiosRequestConfig) {
        return WorkloadOptimizationAPIApiFp(this.configuration).workloadOptimizationAPIDeleteWorkloadScalingPolicy(requestParameters.clusterId, requestParameters.policyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary DisableCluster temporarily disables workload optimization for a cluster. This is an internal-only endpoint used by the admin service.
     * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIDisableClusterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadOptimizationAPIApi
     */
    public workloadOptimizationAPIDisableCluster(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIDisableClusterRequest, options?: RawAxiosRequestConfig) {
        return WorkloadOptimizationAPIApiFp(this.configuration).workloadOptimizationAPIDisableCluster(requestParameters.clusterId, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary EnableCluster re-enables workload optimization for a temporarily disabled cluster. This is an internal-only endpoint used by the admin service.
     * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIEnableClusterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadOptimizationAPIApi
     */
    public workloadOptimizationAPIEnableCluster(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIEnableClusterRequest, options?: RawAxiosRequestConfig) {
        return WorkloadOptimizationAPIApiFp(this.configuration).workloadOptimizationAPIEnableCluster(requestParameters.clusterId, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Requests generation of recommendation for a workload
     * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIGenerateRecommendationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadOptimizationAPIApi
     */
    public workloadOptimizationAPIGenerateRecommendation(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIGenerateRecommendationRequest, options?: RawAxiosRequestConfig) {
        return WorkloadOptimizationAPIApiFp(this.configuration).workloadOptimizationAPIGenerateRecommendation(requestParameters.clusterId, requestParameters.workloadId, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the adoption-weighted CPU billing metric for the given organization+cluster+window.
     * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetAdoptionWeightedCPURequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadOptimizationAPIApi
     */
    public workloadOptimizationAPIGetAdoptionWeightedCPU(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetAdoptionWeightedCPURequest, options?: RawAxiosRequestConfig) {
        return WorkloadOptimizationAPIApiFp(this.configuration).workloadOptimizationAPIGetAdoptionWeightedCPU(requestParameters.clusterId, requestParameters.organizationId, requestParameters.from, requestParameters.to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns status of workload-autoscaler agent.
     * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetAgentStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadOptimizationAPIApi
     */
    public workloadOptimizationAPIGetAgentStatus(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetAgentStatusRequest, options?: RawAxiosRequestConfig) {
        return WorkloadOptimizationAPIApiFp(this.configuration).workloadOptimizationAPIGetAgentStatus(requestParameters.clusterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary GetAggregatedWorkloadCustomMetrics returns aggregated custom metrics time-series data. Pods are aggregated across the workload, grouped by metric name and container.
     * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetAggregatedWorkloadCustomMetricsV1BetaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadOptimizationAPIApi
     */
    public workloadOptimizationAPIGetAggregatedWorkloadCustomMetricsV1Beta(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetAggregatedWorkloadCustomMetricsV1BetaRequest, options?: RawAxiosRequestConfig) {
        return WorkloadOptimizationAPIApiFp(this.configuration).workloadOptimizationAPIGetAggregatedWorkloadCustomMetricsV1Beta(requestParameters.clusterId, requestParameters.workloadId, requestParameters.containerName, requestParameters.fromTime, requestParameters.toTime, requestParameters.aggregationSlidingWindow, requestParameters.aggregationType, requestParameters.step, requestParameters.aggregationPercentile, requestParameters.backfillDataPoints, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns HPA v2 migration eligibility for a cluster
     * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetHPAV2MigrationEligibilityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadOptimizationAPIApi
     */
    public workloadOptimizationAPIGetHPAV2MigrationEligibility(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetHPAV2MigrationEligibilityRequest, options?: RawAxiosRequestConfig) {
        return WorkloadOptimizationAPIApiFp(this.configuration).workloadOptimizationAPIGetHPAV2MigrationEligibility(requestParameters.clusterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns status of workload-autoscaler agents for all clusters in an organization.
     * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetOrganizationAgentStatusesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadOptimizationAPIApi
     */
    public workloadOptimizationAPIGetOrganizationAgentStatuses(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetOrganizationAgentStatusesRequest, options?: RawAxiosRequestConfig) {
        return WorkloadOptimizationAPIApiFp(this.configuration).workloadOptimizationAPIGetOrganizationAgentStatuses(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a workload by a given id.
     * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadOptimizationAPIApi
     */
    public workloadOptimizationAPIGetWorkload(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadRequest, options?: RawAxiosRequestConfig) {
        return WorkloadOptimizationAPIApiFp(this.configuration).workloadOptimizationAPIGetWorkload(requestParameters.clusterId, requestParameters.workloadId, requestParameters.includeMetrics, requestParameters.includeCosts, requestParameters.fromTime, requestParameters.toTime, requestParameters.scopeValue, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns raw custom metrics time-series data for a workload.
     * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadCustomMetricsV1BetaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadOptimizationAPIApi
     */
    public workloadOptimizationAPIGetWorkloadCustomMetricsV1Beta(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadCustomMetricsV1BetaRequest, options?: RawAxiosRequestConfig) {
        return WorkloadOptimizationAPIApiFp(this.configuration).workloadOptimizationAPIGetWorkloadCustomMetricsV1Beta(requestParameters.clusterId, requestParameters.workloadId, requestParameters.containerName, requestParameters.fromTime, requestParameters.toTime, requestParameters.step, requestParameters.backfillDataPoints, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a specific workload event by the given id.
     * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadEventRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadOptimizationAPIApi
     */
    public workloadOptimizationAPIGetWorkloadEvent(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadEventRequest, options?: RawAxiosRequestConfig) {
        return WorkloadOptimizationAPIApiFp(this.configuration).workloadOptimizationAPIGetWorkloadEvent(requestParameters.clusterId, requestParameters.eventId, requestParameters.createdAt, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a workload events summary for given cluster.
     * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadEventsSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadOptimizationAPIApi
     */
    public workloadOptimizationAPIGetWorkloadEventsSummary(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadEventsSummaryRequest, options?: RawAxiosRequestConfig) {
        return WorkloadOptimizationAPIApiFp(this.configuration).workloadOptimizationAPIGetWorkloadEventsSummary(requestParameters.clusterId, requestParameters.fromDate, requestParameters.toDate, requestParameters.workloadId, requestParameters.workloadName, requestParameters.workloadNamespace, requestParameters.workloadKind, requestParameters.type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns workload filter values.
     * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadOptimizationAPIApi
     */
    public workloadOptimizationAPIGetWorkloadFilters(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadFiltersRequest, options?: RawAxiosRequestConfig) {
        return WorkloadOptimizationAPIApiFp(this.configuration).workloadOptimizationAPIGetWorkloadFilters(requestParameters.clusterId, requestParameters.managementOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns step-bucketed GPU utilization time-series and recommendations for a workload.
     * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadGPUMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadOptimizationAPIApi
     */
    public workloadOptimizationAPIGetWorkloadGPUMetrics(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadGPUMetricsRequest, options?: RawAxiosRequestConfig) {
        return WorkloadOptimizationAPIApiFp(this.configuration).workloadOptimizationAPIGetWorkloadGPUMetrics(requestParameters.clusterId, requestParameters.workloadId, requestParameters.from, requestParameters.to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns native VPA spec of the workload by a given id.
     * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadNativeVpaSpecRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadOptimizationAPIApi
     */
    public workloadOptimizationAPIGetWorkloadNativeVpaSpec(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadNativeVpaSpecRequest, options?: RawAxiosRequestConfig) {
        return WorkloadOptimizationAPIApiFp(this.configuration).workloadOptimizationAPIGetWorkloadNativeVpaSpec(requestParameters.clusterId, requestParameters.workloadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the deployed Recommendation CR manifest for the workload, sourced from the latest cluster snapshot.
     * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadRecommendationManifestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadOptimizationAPIApi
     */
    public workloadOptimizationAPIGetWorkloadRecommendationManifest(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadRecommendationManifestRequest, options?: RawAxiosRequestConfig) {
        return WorkloadOptimizationAPIApiFp(this.configuration).workloadOptimizationAPIGetWorkloadRecommendationManifest(requestParameters.clusterId, requestParameters.workloadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns scaling policy.
     * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadScalingPolicyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadOptimizationAPIApi
     */
    public workloadOptimizationAPIGetWorkloadScalingPolicy(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadScalingPolicyRequest, options?: RawAxiosRequestConfig) {
        return WorkloadOptimizationAPIApiFp(this.configuration).workloadOptimizationAPIGetWorkloadScalingPolicy(requestParameters.clusterId, requestParameters.policyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a spec of the workload by a given id.
     * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadSpecRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadOptimizationAPIApi
     */
    public workloadOptimizationAPIGetWorkloadSpec(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadSpecRequest, options?: RawAxiosRequestConfig) {
        return WorkloadOptimizationAPIApiFp(this.configuration).workloadOptimizationAPIGetWorkloadSpec(requestParameters.clusterId, requestParameters.workloadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a workloads access context for a given cluster.
     * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadsAccessContextRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadOptimizationAPIApi
     */
    public workloadOptimizationAPIGetWorkloadsAccessContext(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadsAccessContextRequest, options?: RawAxiosRequestConfig) {
        return WorkloadOptimizationAPIApiFp(this.configuration).workloadOptimizationAPIGetWorkloadsAccessContext(requestParameters.clusterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns workloads optimization summary.
     * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadsSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadOptimizationAPIApi
     */
    public workloadOptimizationAPIGetWorkloadsSummary(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadsSummaryRequest, options?: RawAxiosRequestConfig) {
        return WorkloadOptimizationAPIApiFp(this.configuration).workloadOptimizationAPIGetWorkloadsSummary(requestParameters.clusterId, requestParameters.includeCosts, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns workloads summary time series.
     * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadsSummaryMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadOptimizationAPIApi
     */
    public workloadOptimizationAPIGetWorkloadsSummaryMetrics(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIGetWorkloadsSummaryMetricsRequest, options?: RawAxiosRequestConfig) {
        return WorkloadOptimizationAPIApiFp(this.configuration).workloadOptimizationAPIGetWorkloadsSummaryMetrics(requestParameters.clusterId, requestParameters.fromTime, requestParameters.toTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all HPAs configured on workloads in the given cluster, including workload context (requests, P75 usage, recommendation, current pod count) and an optional converted HPA spec produced by a named converter. The UI is expected to perform aggregation, filtering and pagination client-side.
     * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIListClusterHPAsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadOptimizationAPIApi
     */
    public workloadOptimizationAPIListClusterHPAs(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIListClusterHPAsRequest, options?: RawAxiosRequestConfig) {
        return WorkloadOptimizationAPIApiFp(this.configuration).workloadOptimizationAPIListClusterHPAs(requestParameters.clusterId, requestParameters.workloadNames, requestParameters.namespaces, requestParameters.scalingPolicyNames, requestParameters.kinds, requestParameters.managementOptions, requestParameters.includeConversion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a list of custom metrics data sources for given cluster.
     * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIListCustomMetricsDataSourcesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadOptimizationAPIApi
     */
    public workloadOptimizationAPIListCustomMetricsDataSources(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIListCustomMetricsDataSourcesRequest, options?: RawAxiosRequestConfig) {
        return WorkloadOptimizationAPIApiFp(this.configuration).workloadOptimizationAPIListCustomMetricsDataSources(requestParameters.clusterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a list of limit ranges for given cluster.
     * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIListLimitRangesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadOptimizationAPIApi
     */
    public workloadOptimizationAPIListLimitRanges(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIListLimitRangesRequest, options?: RawAxiosRequestConfig) {
        return WorkloadOptimizationAPIApiFp(this.configuration).workloadOptimizationAPIListLimitRanges(requestParameters.clusterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a list of resource quotas for given cluster.
     * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIListResourceQuotasRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadOptimizationAPIApi
     */
    public workloadOptimizationAPIListResourceQuotas(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIListResourceQuotasRequest, options?: RawAxiosRequestConfig) {
        return WorkloadOptimizationAPIApiFp(this.configuration).workloadOptimizationAPIListResourceQuotas(requestParameters.clusterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a list of workload events for given cluster.
     * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIListWorkloadEventsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadOptimizationAPIApi
     */
    public workloadOptimizationAPIListWorkloadEvents(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIListWorkloadEventsRequest, options?: RawAxiosRequestConfig) {
        return WorkloadOptimizationAPIApiFp(this.configuration).workloadOptimizationAPIListWorkloadEvents(requestParameters.clusterId, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.fromDate, requestParameters.toDate, requestParameters.workloadId, requestParameters.workloadName, requestParameters.workloadNamespace, requestParameters.workloadKind, requestParameters.type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a list of workload scaling policies for given cluster.
     * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIListWorkloadScalingPoliciesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadOptimizationAPIApi
     */
    public workloadOptimizationAPIListWorkloadScalingPolicies(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIListWorkloadScalingPoliciesRequest, options?: RawAxiosRequestConfig) {
        return WorkloadOptimizationAPIApiFp(this.configuration).workloadOptimizationAPIListWorkloadScalingPolicies(requestParameters.clusterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a list of workloads for the given cluster.
     * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIListWorkloadsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadOptimizationAPIApi
     */
    public workloadOptimizationAPIListWorkloads(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIListWorkloadsRequest, options?: RawAxiosRequestConfig) {
        return WorkloadOptimizationAPIApiFp(this.configuration).workloadOptimizationAPIListWorkloads(requestParameters.clusterId, requestParameters.workloadIds, requestParameters.workloadNames, requestParameters.namespaces, requestParameters.scalingPolicyNames, requestParameters.kinds, requestParameters.managementOptions, requestParameters.configuredBy, requestParameters.searchQuery, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.sortField, requestParameters.sortOrder, requestParameters.recommendationStatusType, requestParameters.recommendationIsLowConfidence, requestParameters.workloadHasError, requestParameters.workloadHasCustomMetrics, requestParameters.anyContainerWithRuntime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Migrates all eligible cluster workloads to HPA v2
     * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIMigrateClusterToHPAV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadOptimizationAPIApi
     */
    public workloadOptimizationAPIMigrateClusterToHPAV2(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIMigrateClusterToHPAV2Request, options?: RawAxiosRequestConfig) {
        return WorkloadOptimizationAPIApiFp(this.configuration).workloadOptimizationAPIMigrateClusterToHPAV2(requestParameters.clusterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Partially updates a scaling policy. Only fields covered by the update mask are modified; all other fields keep their current values.
     * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIPatchWorkloadScalingPolicyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadOptimizationAPIApi
     */
    public workloadOptimizationAPIPatchWorkloadScalingPolicy(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIPatchWorkloadScalingPolicyRequest, options?: RawAxiosRequestConfig) {
        return WorkloadOptimizationAPIApiFp(this.configuration).workloadOptimizationAPIPatchWorkloadScalingPolicy(requestParameters.clusterId, requestParameters.policyId, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates a CAST AI managed workload V2 partially using field mask.
     * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIPatchWorkloadV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadOptimizationAPIApi
     */
    public workloadOptimizationAPIPatchWorkloadV2(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIPatchWorkloadV2Request, options?: RawAxiosRequestConfig) {
        return WorkloadOptimizationAPIApiFp(this.configuration).workloadOptimizationAPIPatchWorkloadV2(requestParameters.clusterId, requestParameters.workloadId, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Query workload metrics time series.
     * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIQueryWorkloadMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadOptimizationAPIApi
     */
    public workloadOptimizationAPIQueryWorkloadMetrics(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIQueryWorkloadMetricsRequest, options?: RawAxiosRequestConfig) {
        return WorkloadOptimizationAPIApiFp(this.configuration).workloadOptimizationAPIQueryWorkloadMetrics(requestParameters.clusterId, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resets the system overrides for a workload.
     * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIResetSystemOverridesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadOptimizationAPIApi
     */
    public workloadOptimizationAPIResetSystemOverrides(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIResetSystemOverridesRequest, options?: RawAxiosRequestConfig) {
        return WorkloadOptimizationAPIApiFp(this.configuration).workloadOptimizationAPIResetSystemOverrides(requestParameters.clusterId, requestParameters.workloadId, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Determines the order in which policies are applied to workloads based on assignment rules. By default, policies are sorted by their creation timestamp (CreatedAt).  You MUST provide the complete list of policy IDs in the exact order they should be applied.
     * @summary Updates the order of scaling policies for a given cluster.
     * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPISetScalingPoliciesOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadOptimizationAPIApi
     */
    public workloadOptimizationAPISetScalingPoliciesOrder(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPISetScalingPoliciesOrderRequest, options?: RawAxiosRequestConfig) {
        return WorkloadOptimizationAPIApiFp(this.configuration).workloadOptimizationAPISetScalingPoliciesOrder(requestParameters.clusterId, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary SyncSystemPolicyAssignmentRules syncs assignment rules from system scaling policies to target clusters. This is an internal-only endpoint used by the admin service.
     * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPISyncSystemPolicyAssignmentRulesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadOptimizationAPIApi
     */
    public workloadOptimizationAPISyncSystemPolicyAssignmentRules(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPISyncSystemPolicyAssignmentRulesRequest, options?: RawAxiosRequestConfig) {
        return WorkloadOptimizationAPIApiFp(this.configuration).workloadOptimizationAPISyncSystemPolicyAssignmentRules(requestParameters.organizationId, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates a custom metrics data source.
     * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIUpdateCustomMetricsDataSourceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadOptimizationAPIApi
     */
    public workloadOptimizationAPIUpdateCustomMetricsDataSource(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIUpdateCustomMetricsDataSourceRequest, options?: RawAxiosRequestConfig) {
        return WorkloadOptimizationAPIApiFp(this.configuration).workloadOptimizationAPIUpdateCustomMetricsDataSource(requestParameters.clusterId, requestParameters.id, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates a scaling policy.
     * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIUpdateWorkloadScalingPolicyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadOptimizationAPIApi
     */
    public workloadOptimizationAPIUpdateWorkloadScalingPolicy(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIUpdateWorkloadScalingPolicyRequest, options?: RawAxiosRequestConfig) {
        return WorkloadOptimizationAPIApiFp(this.configuration).workloadOptimizationAPIUpdateWorkloadScalingPolicy(requestParameters.clusterId, requestParameters.policyId, requestParameters.policy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates a CAST AI managed workload V2.
     * @param {WorkloadOptimizationAPIApiWorkloadOptimizationAPIUpdateWorkloadV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadOptimizationAPIApi
     */
    public workloadOptimizationAPIUpdateWorkloadV2(requestParameters: WorkloadOptimizationAPIApiWorkloadOptimizationAPIUpdateWorkloadV2Request, options?: RawAxiosRequestConfig) {
        return WorkloadOptimizationAPIApiFp(this.configuration).workloadOptimizationAPIUpdateWorkloadV2(requestParameters.clusterId, requestParameters.workloadId, requestParameters.workload, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const WorkloadOptimizationAPIGetAggregatedWorkloadCustomMetricsV1BetaAggregationTypeEnum = {
    CUSTOM_METRIC_AGGREGATION_TYPE_UNSPECIFIED: 'CUSTOM_METRIC_AGGREGATION_TYPE_UNSPECIFIED',
    AVERAGE: 'AVERAGE',
    MAX: 'MAX',
    MIN: 'MIN',
    PERCENTILE: 'PERCENTILE'
} as const;
export type WorkloadOptimizationAPIGetAggregatedWorkloadCustomMetricsV1BetaAggregationTypeEnum = typeof WorkloadOptimizationAPIGetAggregatedWorkloadCustomMetricsV1BetaAggregationTypeEnum[keyof typeof WorkloadOptimizationAPIGetAggregatedWorkloadCustomMetricsV1BetaAggregationTypeEnum];
/**
 * @export
 */
export const WorkloadOptimizationAPIGetWorkloadEventsSummaryTypeEnum = {
    INVALID: 'EVENT_TYPE_INVALID',
    SURGE: 'EVENT_TYPE_SURGE',
    OOM_KILL: 'EVENT_TYPE_OOM_KILL',
    CONFIGURATION_CHANGEDV2: 'EVENT_TYPE_CONFIGURATION_CHANGEDV2',
    RECOMMENDED_POD_COUNT_CHANGED: 'EVENT_TYPE_RECOMMENDED_POD_COUNT_CHANGED',
    RECOMMENDED_REQUESTS_CHANGED: 'EVENT_TYPE_RECOMMENDED_REQUESTS_CHANGED',
    SCALING_POLICY_CREATED: 'EVENT_TYPE_SCALING_POLICY_CREATED',
    SCALING_POLICY_DELETED: 'EVENT_TYPE_SCALING_POLICY_DELETED',
    SCALING_POLICY_UPDATED: 'EVENT_TYPE_SCALING_POLICY_UPDATED',
    SCALING_POLICY_ASSIGNED: 'EVENT_TYPE_SCALING_POLICY_ASSIGNED',
    FAILED_HELM_TEST_HOOK: 'EVENT_TYPE_FAILED_HELM_TEST_HOOK',
    SCALING_POLICY_ORDER_UPDATED: 'EVENT_TYPE_SCALING_POLICY_ORDER_UPDATED',
    MEMORY_PRESSURE_EVICTION: 'EVENT_TYPE_MEMORY_PRESSURE_EVICTION',
    SYSTEM_OVERRIDE_TRIGGERED: 'EVENT_TYPE_SYSTEM_OVERRIDE_TRIGGERED',
    SYSTEM_OVERRIDE_RESET: 'EVENT_TYPE_SYSTEM_OVERRIDE_RESET',
    STARTUP_FAILURE: 'EVENT_TYPE_STARTUP_FAILURE',
    CPU_PRESSURE: 'EVENT_TYPE_CPU_PRESSURE',
    HPA_MAXED_OUT: 'EVENT_TYPE_HPA_MAXED_OUT',
    HPA_ALMOST_MAXED_OUT: 'EVENT_TYPE_HPA_ALMOST_MAXED_OUT',
    UNBOUND_MEMORY_GROWTH: 'EVENT_TYPE_UNBOUND_MEMORY_GROWTH',
    CPU_PRESSURE_RESOLVED: 'EVENT_TYPE_CPU_PRESSURE_RESOLVED',
    NATIVE_VPA_STATE_CHANGED: 'EVENT_TYPE_NATIVE_VPA_STATE_CHANGED',
    GPU_RECOMMENDED_REQUESTS_CHANGED: 'EVENT_TYPE_GPU_RECOMMENDED_REQUESTS_CHANGED',
    WORKLOAD_AUTOSCALER_INSTALLED: 'EVENT_TYPE_WORKLOAD_AUTOSCALER_INSTALLED',
    WORKLOAD_AUTOSCALER_UNINSTALLED: 'EVENT_TYPE_WORKLOAD_AUTOSCALER_UNINSTALLED',
    UNSCHEDULABLE_RECOMMENDATION: 'EVENT_TYPE_UNSCHEDULABLE_RECOMMENDATION'
} as const;
export type WorkloadOptimizationAPIGetWorkloadEventsSummaryTypeEnum = typeof WorkloadOptimizationAPIGetWorkloadEventsSummaryTypeEnum[keyof typeof WorkloadOptimizationAPIGetWorkloadEventsSummaryTypeEnum];
/**
 * @export
 */
export const WorkloadOptimizationAPIGetWorkloadFiltersManagementOptionsEnum = {
    UNDEFINED: 'UNDEFINED',
    READ_ONLY: 'READ_ONLY',
    MANAGED: 'MANAGED'
} as const;
export type WorkloadOptimizationAPIGetWorkloadFiltersManagementOptionsEnum = typeof WorkloadOptimizationAPIGetWorkloadFiltersManagementOptionsEnum[keyof typeof WorkloadOptimizationAPIGetWorkloadFiltersManagementOptionsEnum];
/**
 * @export
 */
export const WorkloadOptimizationAPIListClusterHPAsManagementOptionsEnum = {
    UNDEFINED: 'UNDEFINED',
    READ_ONLY: 'READ_ONLY',
    MANAGED: 'MANAGED'
} as const;
export type WorkloadOptimizationAPIListClusterHPAsManagementOptionsEnum = typeof WorkloadOptimizationAPIListClusterHPAsManagementOptionsEnum[keyof typeof WorkloadOptimizationAPIListClusterHPAsManagementOptionsEnum];
/**
 * @export
 */
export const WorkloadOptimizationAPIListClusterHPAsIncludeConversionEnum = {
    HPA_CONVERTER_TYPE_UNSPECIFIED: 'HPA_CONVERTER_TYPE_UNSPECIFIED',
    AVERAGE_VALUE_FROM_ORIGINAL_REQUESTS: 'AVERAGE_VALUE_FROM_ORIGINAL_REQUESTS'
} as const;
export type WorkloadOptimizationAPIListClusterHPAsIncludeConversionEnum = typeof WorkloadOptimizationAPIListClusterHPAsIncludeConversionEnum[keyof typeof WorkloadOptimizationAPIListClusterHPAsIncludeConversionEnum];
/**
 * @export
 */
export const WorkloadOptimizationAPIListWorkloadEventsTypeEnum = {
    INVALID: 'EVENT_TYPE_INVALID',
    SURGE: 'EVENT_TYPE_SURGE',
    OOM_KILL: 'EVENT_TYPE_OOM_KILL',
    CONFIGURATION_CHANGEDV2: 'EVENT_TYPE_CONFIGURATION_CHANGEDV2',
    RECOMMENDED_POD_COUNT_CHANGED: 'EVENT_TYPE_RECOMMENDED_POD_COUNT_CHANGED',
    RECOMMENDED_REQUESTS_CHANGED: 'EVENT_TYPE_RECOMMENDED_REQUESTS_CHANGED',
    SCALING_POLICY_CREATED: 'EVENT_TYPE_SCALING_POLICY_CREATED',
    SCALING_POLICY_DELETED: 'EVENT_TYPE_SCALING_POLICY_DELETED',
    SCALING_POLICY_UPDATED: 'EVENT_TYPE_SCALING_POLICY_UPDATED',
    SCALING_POLICY_ASSIGNED: 'EVENT_TYPE_SCALING_POLICY_ASSIGNED',
    FAILED_HELM_TEST_HOOK: 'EVENT_TYPE_FAILED_HELM_TEST_HOOK',
    SCALING_POLICY_ORDER_UPDATED: 'EVENT_TYPE_SCALING_POLICY_ORDER_UPDATED',
    MEMORY_PRESSURE_EVICTION: 'EVENT_TYPE_MEMORY_PRESSURE_EVICTION',
    SYSTEM_OVERRIDE_TRIGGERED: 'EVENT_TYPE_SYSTEM_OVERRIDE_TRIGGERED',
    SYSTEM_OVERRIDE_RESET: 'EVENT_TYPE_SYSTEM_OVERRIDE_RESET',
    STARTUP_FAILURE: 'EVENT_TYPE_STARTUP_FAILURE',
    CPU_PRESSURE: 'EVENT_TYPE_CPU_PRESSURE',
    HPA_MAXED_OUT: 'EVENT_TYPE_HPA_MAXED_OUT',
    HPA_ALMOST_MAXED_OUT: 'EVENT_TYPE_HPA_ALMOST_MAXED_OUT',
    UNBOUND_MEMORY_GROWTH: 'EVENT_TYPE_UNBOUND_MEMORY_GROWTH',
    CPU_PRESSURE_RESOLVED: 'EVENT_TYPE_CPU_PRESSURE_RESOLVED',
    NATIVE_VPA_STATE_CHANGED: 'EVENT_TYPE_NATIVE_VPA_STATE_CHANGED',
    GPU_RECOMMENDED_REQUESTS_CHANGED: 'EVENT_TYPE_GPU_RECOMMENDED_REQUESTS_CHANGED',
    WORKLOAD_AUTOSCALER_INSTALLED: 'EVENT_TYPE_WORKLOAD_AUTOSCALER_INSTALLED',
    WORKLOAD_AUTOSCALER_UNINSTALLED: 'EVENT_TYPE_WORKLOAD_AUTOSCALER_UNINSTALLED',
    UNSCHEDULABLE_RECOMMENDATION: 'EVENT_TYPE_UNSCHEDULABLE_RECOMMENDATION'
} as const;
export type WorkloadOptimizationAPIListWorkloadEventsTypeEnum = typeof WorkloadOptimizationAPIListWorkloadEventsTypeEnum[keyof typeof WorkloadOptimizationAPIListWorkloadEventsTypeEnum];
/**
 * @export
 */
export const WorkloadOptimizationAPIListWorkloadsManagementOptionsEnum = {
    UNDEFINED: 'UNDEFINED',
    READ_ONLY: 'READ_ONLY',
    MANAGED: 'MANAGED'
} as const;
export type WorkloadOptimizationAPIListWorkloadsManagementOptionsEnum = typeof WorkloadOptimizationAPIListWorkloadsManagementOptionsEnum[keyof typeof WorkloadOptimizationAPIListWorkloadsManagementOptionsEnum];
/**
 * @export
 */
export const WorkloadOptimizationAPIListWorkloadsSortOrderEnum = {
    ASC: 'ASC',
    asc: 'asc',
    DESC: 'DESC',
    desc: 'desc'
} as const;
export type WorkloadOptimizationAPIListWorkloadsSortOrderEnum = typeof WorkloadOptimizationAPIListWorkloadsSortOrderEnum[keyof typeof WorkloadOptimizationAPIListWorkloadsSortOrderEnum];
/**
 * @export
 */
export const WorkloadOptimizationAPIListWorkloadsRecommendationStatusTypeEnum = {
    UNKNOWN: 'STATUS_UNKNOWN',
    WAITING: 'STATUS_WAITING',
    APPLIED: 'STATUS_APPLIED',
    STOPPED: 'STATUS_STOPPED'
} as const;
export type WorkloadOptimizationAPIListWorkloadsRecommendationStatusTypeEnum = typeof WorkloadOptimizationAPIListWorkloadsRecommendationStatusTypeEnum[keyof typeof WorkloadOptimizationAPIListWorkloadsRecommendationStatusTypeEnum];
/**
 * @export
 */
export const WorkloadOptimizationAPIListWorkloadsAnyContainerWithRuntimeEnum = {
    RUNTIME_UNSPECIFIED: 'RUNTIME_UNSPECIFIED',
    JVM: 'JVM',
    GPU: 'GPU'
} as const;
export type WorkloadOptimizationAPIListWorkloadsAnyContainerWithRuntimeEnum = typeof WorkloadOptimizationAPIListWorkloadsAnyContainerWithRuntimeEnum[keyof typeof WorkloadOptimizationAPIListWorkloadsAnyContainerWithRuntimeEnum];
